// Trạm điều hành VClaw: kiểu dữ liệu của /api/vclaw/* + các hàm lọc/nhóm/định dạng THUẦN (test ở tests/vclaw.test.ts và tests/vclaw-v2.test.ts).
// PHẦN THUẦN: không import react/api (tsconfig.test chỉ có lib ES2023, không DOM). Hook react-query của /api/vclaw/su-kien và /bo-nho nằm ở lib/du-lieu.ts.
import { kieuChayVclaw, KHOANG_QUOTA, LOAI_BO_NHO, MAU_MA_AGENT, PHUT_CHAM, TOI_DA_MAU_HO_SO, tuoiPhut, vclawKhongPhanHoi } from '../../server/vclaw-kieu';
import type {
  AgentsVclaw, BaoMatVclaw, CachChayVclaw, CaiDatVclaw, CanhBaoVclaw, ChiMucBoNho, ChiSoBieuDo, ChuoiBieuDo, DoSanSangVclaw, DongChat, HoSoVclaw, KetQuaLich, KhoangQuota, KieuChayVclaw, LichChayVclaw, LoaiBoNho, LoaiLoiViec,
  LoaiSuKien, MauQuota, MucAgent, MucBoNho, MucLichChay, NganSachVclaw, NgaySuDung, SucKhoeVclaw, SuDungVclaw, SuKienVclaw, TrangThaiAgent, TrangThaiVclaw, ViecSoCai, ViecVclaw,
} from '../../server/vclaw-kieu';
import { chuanHoaTuKhoa, gapChuTim, HUONG_TIN, taoBoKhop, viTriKhop } from '../../server/vclaw-kieu';
import type { HuongTin, KetQuaTimChat, SoNgayTim } from '../../server/vclaw-kieu';
import { diaChiPhongTacChien, laNgayHopLe } from '../../server/vclaw-kieu';
import type { DongHop, KieuTinHopHoacKhac, PhongHop, WarRoomVclaw } from '../../server/vclaw-kieu';
import { boDau } from './nhan';
import { laMucTieu, thongTinTt, thuTuUuTien, type TrangThai, type Viec } from './viec';

export type {
  AgentsVclaw, BaoMatVclaw, CachChayVclaw, CaiDatVclaw, CanhBaoVclaw, ChiMucBoNho, DoSanSangVclaw, DongChat, HoSoVclaw, KetQuaLich, KhoangQuota, LichChayVclaw, LoaiBoNho, LoaiLoiViec, LoaiSuKien, MauQuota, MucAgent, MucBoNho,
  MucLichChay, NganSachVclaw, NgaySuDung, SucKhoeVclaw, SuDungVclaw, SuKienVclaw, TrangThaiAgent, TrangThaiVclaw, ViecSoCai, ViecVclaw,
};

export type TraTrangThai = { co: boolean; repo: string; trang_thai: TrangThaiVclaw | null; tuoi_phut: number | null; suc_khoe: SucKhoeVclaw };
export type TraLichSu = { co: boolean; repo: string; ngay: string | null; ngay_co: string[]; ds: DongChat[]; tong: number; cat?: boolean };
/** GET /api/vclaw/su-kien — `co` = tệp sự kiện của `ngay` có tồn tại; `cat` = còn nhiều hơn 400 dòng (chỉ giữ 400 mới nhất). */
export type TraSuKien = { co: boolean; repo: string; ngay: string; ds: SuKienVclaw[]; tong: number; cat: boolean };
/** GET /api/vclaw/bo-nho — `co` = tệp memory/index.json có và đọc được. */
export type TraBoNho = { co: boolean; repo: string; chi_muc: ChiMucBoNho | null };
/** GET /api/vclaw/viec — `co` = tệp jobs của `ngay` có tồn tại; `cat` = ngày có nhiều hơn 500 việc (chỉ giữ 500 mới nhất). */
export type TraViecVclaw = { co: boolean; repo: string; ngay: string; ds: ViecSoCai[]; tong: number; cat: boolean };
/** GET /api/vclaw/quota — `co` = có ít nhất một tệp quota trong khoảng; `mau` đã lọc theo khoảng, cũ → mới, tối đa 400. */
export type TraQuotaVclaw = { co: boolean; repo: string; khoang: KhoangQuota; mau: MauQuota[] };

export const NHAN_SUC_KHOE: Record<SucKhoeVclaw, { ten: string; lop: string }> = {
  online: { ten: 'Đang chạy', lop: 'bg-xanh-nhat text-xanh' },
  cham: { ten: 'Chậm tín hiệu', lop: 'bg-cam-nhat text-cam-chu' },
  'mat-tin-hieu': { ten: 'Mất tín hiệu', lop: 'bg-do-nhat text-do' },
  'chua-co': { ten: 'Chưa có dữ liệu', lop: 'bg-mat-noi text-chu-phu' },
};

/** Quota đã dùng (%): dưới 70 yên tâm, 70–90 để ý, từ 90 là ngưỡng VClaw tự đổi seat. Không có số → null. */
export function mucQuota(pt: number | null): 'tot' | 'chu-y' | 'cao' | null {
  if (pt === null || !Number.isFinite(pt)) return null;
  return pt >= 90 ? 'cao' : pt >= 70 ? 'chu-y' : 'tot';
}
export const MAU_QUOTA = { tot: 'var(--luc)', 'chu-y': 'var(--cam)', cao: 'var(--do)' } as const;

const h2 = (n: number) => String(n).padStart(2, '0');

/** epoch GIÂY → "HH:mm dd/MM" theo giờ máy; đã qua → 'đã hồi'; không có → '—'. */
export function gioReset(epoch: number | null, bay_gio = Date.now()): string {
  if (epoch === null || !Number.isFinite(epoch)) return '—';
  if (epoch * 1000 <= bay_gio) return 'đã hồi';
  const d = new Date(epoch * 1000);
  return `${h2(d.getHours())}:${h2(d.getMinutes())} ${h2(d.getDate())}/${h2(d.getMonth() + 1)}`;
}

export function thoiGianChay(tu_iso: string, den: number = Date.now()): string {
  const t = Date.parse(tu_iso);
  if (Number.isNaN(t)) return '—';
  const p = Math.max(0, Math.floor((den - t) / 60_000));
  if (p < 60) return `${p} phút`;
  const g = Math.floor(p / 60);
  return g < 48 ? `${g} giờ ${p % 60} phút` : `${Math.floor(g / 24)} ngày`;
}

export function gioTrongNgay(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : `${h2(d.getHours())}:${h2(d.getMinutes())}`;
}

/** Chân tin trả lời: model · hồ sơ · giây · chi phí quy đổi. Bỏ mục thiếu. */
export function chanTin(meta: DongChat['meta']): string {
  const ra: string[] = [];
  if (typeof meta.model === 'string') ra.push(meta.model.replace(/^claude-/, '').replace(/\[.*\]$/, ''));
  if (typeof meta.profile === 'string' && meta.profile) ra.push(meta.profile);
  if (typeof meta.seconds === 'number') ra.push(meta.seconds < 60 ? `${meta.seconds}s` : `${Math.floor(meta.seconds / 60)}p${h2(meta.seconds % 60)}s`);
  if (typeof meta.cost === 'number' && meta.cost > 0) ra.push(`~$${meta.cost.toFixed(2)}`);
  return ra.join(' · ');
}

/** Tên model gọn để hiện trong bảng: bỏ tiền tố "claude-" và hậu tố ngữ cảnh "[1m]" ("claude-sonnet-5-5[1m]" → "sonnet-5-5"). Không phải chuỗi → "". */
export const modelGon = (model: unknown): string => (typeof model === 'string' ? model.replace(/^claude-/, '').replace(/\[.*\]$/, '') : '');

export const NHAN_HUONG: Record<DongChat['dir'], string> = { in: 'Bạn', out: 'VClaw', sys: 'Hệ thống' };

/** Lọc tin theo chữ — KHÔNG phân biệt hoa thường và dấu tiếng Việt, dãy khoảng trắng / xuống dòng tính là một dấu cách; rỗng = giữ hết.
 *  Dùng đúng hàm gập chữ của "Tìm chat nhiều ngày" (server/vclaw-kieu.ts): tin nào máy chủ báo khớp thì ô lọc trong ngày cũng thấy khớp khi bấm một kết quả để sang xem ngày đó. */
export function locTin(ds: DongChat[], q: string): DongChat[] {
  if (chuanHoaTuKhoa(q) === '') return ds;
  const khop = taoBoKhop(q);
  return ds.filter((d) => khop(d.text));
}

// ── Hive mind: nhãn + lọc + tóm tắt sự kiện ──
export type NhomSuKien = 'viec' | 'agent' | 'seat' | 'he-thong' | 'bao-mat' | 'canh-bao' | 'lich' | 'tep' | 'khac';
/** Nhóm cho ô lọc của dòng thời gian (thứ tự hiện trên giao diện). */
export const NHOM_SU_KIEN: { ma: NhomSuKien; ten: string }[] = [
  { ma: 'viec', ten: 'Công việc' },
  { ma: 'agent', ten: 'Đội agent' },
  { ma: 'seat', ten: 'Đổi seat · quota' },
  { ma: 'he-thong', ten: 'Hệ thống' },
  { ma: 'bao-mat', ten: 'Khoá · dừng khẩn' },
  { ma: 'canh-bao', ten: 'Cảnh báo' },
  { ma: 'lich', ten: 'Lịch chạy' },
  { ma: 'tep', ten: 'Tệp qua Telegram' },
  { ma: 'khac', ten: 'Khác' },
];
export const NHAN_SU_KIEN: Record<LoaiSuKien, { ten: string; nhom: NhomSuKien }> = {
  start: { ten: 'VClaw khởi động', nhom: 'he-thong' },
  stop: { ten: 'VClaw dừng', nhom: 'he-thong' },
  stale: { ten: 'Bỏ qua tin cũ', nhom: 'he-thong' },
  job_start: { ten: 'Bắt đầu việc', nhom: 'viec' },
  job_ok: { ten: 'Việc xong', nhom: 'viec' },
  job_fail: { ten: 'Việc lỗi', nhom: 'viec' },
  switch: { ten: 'Đổi seat', nhom: 'seat' },
  quota_wait: { ten: 'Chờ quota', nhom: 'seat' },
  lock: { ten: 'Khoá bằng PIN', nhom: 'bao-mat' },
  unlock: { ten: 'Mở khoá', nhom: 'bao-mat' },
  kill: { ten: 'Dừng khẩn', nhom: 'bao-mat' },
  alert: { ten: 'Cảnh báo', nhom: 'canh-bao' },
  routine_start: { ten: 'Lịch bắt đầu chạy', nhom: 'lich' },
  routine_skip: { ten: 'Lịch bị bỏ qua', nhom: 'lich' },
  routine_error: { ten: 'Tệp lịch có lỗi', nhom: 'lich' },
  file_in: { ten: 'Nhận tệp từ điện thoại', nhom: 'tep' },
  file_sent: { ten: 'Gửi tệp về điện thoại', nhom: 'tep' },
  agent_job: { ten: 'Việc của agent', nhom: 'agent' },
  agent_delegate: { ten: 'Agent giao việc', nhom: 'agent' },
  agent_error: { ten: 'Danh bạ agent có lỗi', nhom: 'agent' },
  meeting: { ten: 'Cuộc họp phòng tác chiến', nhom: 'agent' },
  warroom_start: { ten: 'Phòng tác chiến mở', nhom: 'agent' },
  warroom_error: { ten: 'Phòng tác chiến không mở được', nhom: 'agent' },
  khac: { ten: 'Sự kiện khác', nhom: 'khac' },
};
/** Nhãn của một loại; loại ngoài bảng (không xảy ra với dữ liệu đã làm sạch) → "Sự kiện khác". */
export const nhanSuKien = (kind: string): { ten: string; nhom: NhomSuKien } => (Object.hasOwn(NHAN_SU_KIEN, kind) ? NHAN_SU_KIEN[kind as LoaiSuKien] : NHAN_SU_KIEN.khac);

/** Khớp KHÔNG DẤU, không phân biệt hoa/thường; nhiều từ thì phải khớp đủ mọi từ (không cần liền nhau). Truy vấn rỗng = khớp hết. */
function khopTuKhoa(kho: string, q: string): boolean {
  const tu = boDau(q).split(/\s+/).filter(Boolean);
  if (!tu.length) return true;
  const h = boDau(kho);
  return tu.every((t) => h.includes(t));
}

export type LocSuKien = { nhom?: NhomSuKien | null; kind?: LoaiSuKien | null; q?: string };
/** Lọc theo nhóm / loại / chữ (tìm trong nhãn, văn bản, hồ sơ, model). Mọi điều kiện bỏ trống = giữ hết; giữ nguyên thứ tự. */
export function locSuKien(ds: SuKienVclaw[], loc: LocSuKien = {}): SuKienVclaw[] {
  const q = loc.q ?? '';
  return (Array.isArray(ds) ? ds : []).filter((s) => {
    const nhan = nhanSuKien(s.kind);
    if (loc.nhom && nhan.nhom !== loc.nhom) return false;
    if (loc.kind && s.kind !== loc.kind) return false;
    return khopTuKhoa(`${nhan.ten} ${s.text} ${s.profile} ${s.model}`, q);
  });
}

export type TomTatSuKien = {
  tong: number; viec_xong: number; viec_loi: number; doi_seat: number; cho_quota: number;
  /** `ts` của sự kiện mới nhất; không có sự kiện → null. */
  cuoi: string | null;
  theo_loai: Partial<Record<LoaiSuKien, number>>;
};
/** Đếm sự kiện cho dòng tóm tắt đầu mảng Hive mind ("12 sự kiện · 5 việc xong · 1 lỗi · 2 lần đổi seat"). */
export function tomTatSuKien(ds: SuKienVclaw[]): TomTatSuKien {
  const t: TomTatSuKien = { tong: 0, viec_xong: 0, viec_loi: 0, doi_seat: 0, cho_quota: 0, cuoi: null, theo_loai: {} };
  let cuoi_ms = -Infinity;
  for (const s of Array.isArray(ds) ? ds : []) {
    t.tong++;
    t.theo_loai[s.kind] = (t.theo_loai[s.kind] ?? 0) + 1;
    if (s.kind === 'job_ok') t.viec_xong++;
    else if (s.kind === 'job_fail') t.viec_loi++;
    else if (s.kind === 'switch') t.doi_seat++;
    else if (s.kind === 'quota_wait') t.cho_quota++;
    const ms = Date.parse(s.ts);
    if (ms > cuoi_ms) { cuoi_ms = ms; t.cuoi = s.ts; }
  }
  return t;
}

// ── Bộ nhớ (memory timeline): lọc + nhóm theo tháng ──
export type LocBoNho = { loai?: LoaiBoNho | null; q?: string };
/** Lọc theo loại + chữ KHÔNG DẤU (tìm trong tiêu đề, tóm tắt, tag, đường dẫn). Giữ nguyên thứ tự. */
export function locBoNho(items: MucBoNho[], loc: LocBoNho = {}): MucBoNho[] {
  const q = loc.q ?? '';
  return (Array.isArray(items) ? items : []).filter((m) => (!loc.loai || m.type === loc.loai) && khopTuKhoa(`${m.title} ${m.summary} ${m.tags.join(' ')} ${m.id}`, q));
}
/** Số mục theo loại (cho ô lọc; luôn đủ 7 loại, loại không có = 0). */
export function demBoNhoTheoLoai(items: MucBoNho[]): Record<LoaiBoNho, number> {
  const d = {} as Record<LoaiBoNho, number>;
  for (const l of LOAI_BO_NHO) d[l] = 0;
  for (const m of Array.isArray(items) ? items : []) if (Object.hasOwn(d, m.type)) d[m.type]++;
  return d;
}

export type NhomBoNho = { ma: string; ten: string; muc: MucBoNho[] };
export const MA_NHOM_BEN = 'ben';
export const MA_NHOM_KHONG_NGAY = 'khong-ngay';
/** Nhóm cho dòng thời gian: "Ghi nhớ bền" (mọi mục MEMORY — không có ngày) ĐẦU TIÊN, rồi từng tháng MỚI NHẤT TRƯỚC (trong tháng: ngày mới trước),
 *  mục không ngày (khác MEMORY) xuống CUỐI. Nhóm rỗng không xuất hiện. Không đổi mảng vào. */
export function nhomBoNhoTheoThang(items: MucBoNho[]): NhomBoNho[] {
  const ben: MucBoNho[] = [], khong_ngay: MucBoNho[] = [];
  const theo_thang = new Map<string, MucBoNho[]>();
  for (const m of Array.isArray(items) ? items : []) {
    if (m.type === 'MEMORY') { ben.push(m); continue; }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(m.date)) { khong_ngay.push(m); continue; }
    const thang = m.date.slice(0, 7);
    const ds = theo_thang.get(thang);
    if (ds) ds.push(m); else theo_thang.set(thang, [m]);
  }
  const ra: NhomBoNho[] = [];
  if (ben.length) ra.push({ ma: MA_NHOM_BEN, ten: 'Ghi nhớ bền', muc: ben });
  for (const thang of [...theo_thang.keys()].sort().reverse()) {
    const muc = [...theo_thang.get(thang)!].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
    ra.push({ ma: thang, ten: `Tháng ${thang.slice(5)}/${thang.slice(0, 4)}`, muc });
  }
  if (khong_ngay.length) ra.push({ ma: MA_NHOM_KHONG_NGAY, ten: 'Không rõ ngày', muc: khong_ngay });
  return ra;
}

// ── Mission Control: việc theo cột trạng thái ──
/** Bốn cột việc đang mở; cột "Xong" luôn đứng sau cùng. Inbox (chưa phân loại) không có cột. */
export const COT_MISSION_CONTROL: TrangThai[] = ['tt:san-sang', 'tt:dang-chay', 'tt:cho-duyet', 'tt:tac-nghen'];
/** Trần thẻ vẽ mỗi cột đang mở (số đếm `tong` vẫn là số thật) và số việc Xong mới nhất. */
export const TOI_DA_THE_MOI_COT = 40;
export const TOI_DA_VIEC_XONG = 5;
export type CotMissionControl = { tt: TrangThai; ten: string; mau: string; viec: Viec[]; tong: number };

const tgMs = (iso: string | null | undefined) => (iso ? Date.parse(iso) : NaN);
/** 5 cột (Sẵn sàng, Đang làm, Chờ duyệt, Tắc nghẽn, Xong — luôn đủ 5, cột trống có tong = 0). Bỏ mục tiêu OKR (có trang riêng). `agent` = giá trị
 *  `Viec.agent` đầy đủ ("agent:claude") để chỉ lấy việc của agent đó; null = tất cả. Cột mở: ưu tiên P0→P3 rồi mới cập nhật trước;
 *  cột Xong: 5 việc đóng gần nhất. */
export function nhomMissionControl(ds: Viec[], agent: string | null = null): CotMissionControl[] {
  const dau_vao = (Array.isArray(ds) ? ds : []).filter((v) => !laMucTieu(v) && (agent === null || v.agent === agent));
  const cot = (tt: TrangThai, tran: number, xep: (a: Viec, b: Viec) => number): CotMissionControl => {
    const tat_ca = dau_vao.filter((v) => (v.mo ? v.tt : 'xong') === tt).sort(xep);
    return { tt, ...tenMau(tt), viec: tat_ca.slice(0, tran), tong: tat_ca.length };
  };
  const theo_uu_tien = (a: Viec, b: Viec) => thuTuUuTien(a.uu_tien) - thuTuUuTien(b.uu_tien) || tgMs(b.cap_nhat_luc) - tgMs(a.cap_nhat_luc) || b.so - a.so;
  const theo_dong = (a: Viec, b: Viec) => tgMs(b.dong_luc ?? b.cap_nhat_luc) - tgMs(a.dong_luc ?? a.cap_nhat_luc) || b.so - a.so;
  return [...COT_MISSION_CONTROL.map((tt) => cot(tt, TOI_DA_THE_MOI_COT, theo_uu_tien)), cot('xong', TOI_DA_VIEC_XONG, theo_dong)];
}
const tenMau = (tt: TrangThai) => { const t = thongTinTt(tt); return { ten: t.ten, mau: t.mau }; };

/** Agent có việc đang mở trên bảng (4 cột), nhiều việc nhất trước — cho ô lọc nhanh theo agent. Giá trị `agent` là nhãn đầy đủ ("agent:claude"). */
export function cacAgentMissionControl(ds: Viec[]): { agent: string; so: number }[] {
  const dem = new Map<string, number>();
  for (const v of Array.isArray(ds) ? ds : []) {
    if (laMucTieu(v) || !v.mo || !v.agent || !COT_MISSION_CONTROL.includes(v.tt)) continue;
    dem.set(v.agent, (dem.get(v.agent) ?? 0) + 1);
  }
  return [...dem].map(([agent, so]) => ({ agent, so })).sort((a, b) => b.so - a.so || (a.agent < b.agent ? -1 : a.agent > b.agent ? 1 : 0));
}

// ── Định dạng số (dấu phẩy thập phân, dấu chấm hàng nghìn — kiểu Việt Nam; viết tay để kết quả giống hệt mọi môi trường) ──
const thapPhan = (n: number) => String(n).replace('.', ',');
/** Số gọn cho token/đếm: 950 → "950", 1234 → "1,2K", 1 500 000 → "1,5M", 2 500 000 000 → "2,5B". Không phải số hữu hạn → "—". */
export function soGon(n: number | null | undefined): string {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  const dau = n < 0 ? '-' : '';
  const don_vi = ['', 'K', 'M', 'B', 'T'];
  let v = Math.abs(n), i = 0;
  while (v >= 1000 && i < don_vi.length - 1) { v /= 1000; i++; }
  let r = i === 0 ? Math.round(v) : Math.round(v * 10) / 10;
  if (r >= 1000 && i < don_vi.length - 1) { r = Math.round(r / 100) / 10; i++; } // 999 950 → "1M", không phải "1000K"
  return dau + thapPhan(r) + don_vi[i];
}
/** USD ƯỚC TÍNH: 0 → "$0", dưới nửa xu → "<$0,01", dưới 1 000 hai số lẻ ("$1,23"), từ 1 000 bỏ số lẻ ("$1.235"). Không phải số hữu hạn → "—". */
export function usd(n: number | null | undefined): string {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  const dau = n < 0 ? '-' : '';
  const a = Math.abs(n);
  if (a === 0) return '$0';
  if (a < 0.005) return dau + '<$0,01';
  const nhom = (s: string) => s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  if (a >= 999.995) return `${dau}$${nhom(String(Math.round(a)))}`; // 999,996 làm tròn thành 1.000 chứ không phải "1000,00"
  const [nguyen, le] = a.toFixed(2).split('.');
  return `${dau}$${nguyen},${le}`;
}
/** Phần trăm gọn: số nguyên thì không số lẻ ("100%"), còn lại một số lẻ kiểu Việt ("93,3%"). KHÔNG làm tròn lên 100% khi còn việc lỗi (99,96 → "99,9%") và không làm tròn
 *  xuống 0% khi còn việc xong (0,02 → "0,1%"). Ngoài 0–100 thì chặn lại; không phải số hữu hạn → "—". */
export function nhanPhanTram(pct: number | null | undefined): string {
  if (typeof pct !== 'number' || !Number.isFinite(pct)) return '—';
  const p = Math.min(100, Math.max(0, pct));
  const r = Math.round(p * 10) / 10;
  return `${thapPhan(r >= 100 && p < 100 ? 99.9 : r <= 0 && p > 0 ? 0.1 : r)}%`;
}
/** Số giây → "45 giây", "7 phút 36 giây", "2 giờ 5 phút", "1 ngày 3 giờ". Âm / không hữu hạn → "—". */
export function thoiLuong(giay: number | null | undefined): string {
  if (typeof giay !== 'number' || !Number.isFinite(giay) || giay < 0) return '—';
  const s = Math.round(giay);
  if (s < 60) return `${s} giây`;
  const p = Math.floor(s / 60);
  if (p < 60) return `${p} phút` + (s % 60 ? ` ${s % 60} giây` : '');
  const g = Math.floor(p / 60);
  if (g < 24) return `${g} giờ` + (p % 60 ? ` ${p % 60} phút` : '');
  return `${Math.floor(g / 24)} ngày` + (g % 24 ? ` ${g % 24} giờ` : '');
}
/** "vừa xong" / "12 phút trước" / "3 giờ trước" / "2 ngày trước"; không có / sai ngày → "—". Mốc ở tương lai (lệch đồng hồ) tính là "vừa xong". */
export function tuoiTuongDoi(iso: string | null | undefined, bay_gio: number = Date.now()): string {
  const t = typeof iso === 'string' ? Date.parse(iso) : NaN;
  if (Number.isNaN(t)) return '—';
  const p = Math.floor((bay_gio - t) / 60_000);
  if (p < 1) return 'vừa xong';
  if (p < 60) return `${p} phút trước`;
  const g = Math.floor(p / 60);
  return g < 48 ? `${g} giờ trước` : `${Math.floor(g / 24)} ngày trước`;
}
/** "2026-10-13" → "13/10" (nhãn trục biểu đồ); sai dạng → "—". */
export const ngayNgan = (ngay: string): string => (/^\d{4}-\d{2}-\d{2}$/.test(ngay) ? `${ngay.slice(8, 10)}/${ngay.slice(5, 7)}` : '—');
/** ISO → "HH:mm dd/MM" theo giờ máy; sai / không có → "—". */
export function gioVaNgay(iso: string | null | undefined): string {
  const t = typeof iso === 'string' ? Date.parse(iso) : NaN;
  if (Number.isNaN(t)) return '—';
  const d = new Date(t);
  return `${h2(d.getHours())}:${h2(d.getMinutes())} ${h2(d.getDate())}/${h2(d.getMonth() + 1)}`;
}

// ── Cài đặt VClaw (chỉ đọc): dựng các dòng nhãn – giá trị cho giao diện ──
export type DongCaiDat = { nhan: string; gia_tri: string; /** giá trị là mã / tên kỹ thuật → hiện chữ đơn cách */ ma?: boolean };
export type NhomCaiDat = { ten: string; dong: DongCaiDat[] };
const hienChu = (s: string) => (s ? s : '—');
const hienBatTat = (v: boolean | null) => (v === true ? 'Bật' : v === false ? 'Tắt' : '—');
const hienDaDat = (v: boolean | null) => (v === true ? 'Đã đặt' : v === false ? 'Chưa đặt' : '—');
const hienSo = (v: number | null, hau_to = '') => (v === null ? '—' : `${v}${hau_to}`);
const hienGiay = (v: number | null) => (v === null ? '—' : thoiLuong(v));
/** settings đã làm sạch → năm nhóm nhãn – giá trị. Giá trị không biết (null / rỗng) hiện "—". Bí mật không bao giờ có ở đây: PIN và cụm từ dừng khẩn
 *  chỉ là "Đã đặt / Chưa đặt" (lõi làm sạch không nhận giá trị thật của chúng), token không có trường nào. */
export function dongCaiDat(c: CaiDatVclaw): NhomCaiDat[] {
  return [
    {
      ten: 'Model',
      dong: [
        { nhan: 'Mặc định', gia_tri: hienChu(c.model_default), ma: true },
        { nhan: 'Đang dùng', gia_tri: hienChu(c.model_effective), ma: true },
        { nhan: 'Effort', gia_tri: hienChu(c.effort), ma: true },
        ...c.model_choices.map((m) => ({ nhan: `Bí danh “${m.alias}”`, gia_tri: m.model, ma: true })),
      ],
    },
    {
      ten: 'Chạy việc',
      dong: [
        { nhan: 'Chế độ quyền', gia_tri: hienChu(c.permission_mode), ma: true },
        { nhan: 'MCP', gia_tri: hienChu(c.mcp), ma: true },
        { nhan: 'Việc chạy song song tối đa', gia_tri: hienSo(c.max_parallel_jobs) },
        { nhan: 'Thời gian tối đa một việc', gia_tri: hienGiay(c.timeout_sec) },
        { nhan: 'Hết giờ khi im lặng', gia_tri: hienGiay(c.idle_timeout_sec) },
        { nhan: 'Công cụ bị chặn', gia_tri: hienSo(c.disallowed_tools, ' công cụ') },
      ],
    },
    {
      ten: 'Quota và đổi seat',
      dong: [
        { nhan: 'Ngưỡng đổi seat — quota 5 giờ', gia_tri: hienSo(c.quota.threshold_5h, '%') },
        { nhan: 'Ngưỡng đổi seat — quota 7 ngày', gia_tri: hienSo(c.quota.threshold_7d, '%') },
        { nhan: 'Đổi seat khi rảnh', gia_tri: hienBatTat(c.quota.switch_when_idle) },
        { nhan: 'Đổi seat giữa lúc đang chạy việc', gia_tri: hienBatTat(c.quota.switch_mid_job) },
      ],
    },
    {
      ten: 'Bảo mật',
      dong: [
        { nhan: 'PIN', gia_tri: hienDaDat(c.security.pin_set) },
        { nhan: 'Tự khoá sau', gia_tri: hienSo(c.security.idle_lock_minutes, ' phút') },
        { nhan: 'Người được phép nhắn bot', gia_tri: hienSo(c.security.allowed_users, ' người') },
        { nhan: 'Cụm từ dừng khẩn', gia_tri: hienDaDat(c.security.kill_phrase_set) },
      ],
    },
    {
      ten: 'Lịch sử chat (repo ChatLog)',
      dong: [
        { nhan: 'Repo', gia_tri: hienChu(c.chatlog.repo), ma: true },
        { nhan: 'Đồng bộ mỗi', gia_tri: hienGiay(c.chatlog.sync_every_sec) },
        { nhan: 'Che bí mật khi đẩy lên', gia_tri: hienBatTat(c.chatlog.redact) },
      ],
    },
  ];
}

// ── Mô tả sự kiện + bộ nhớ ──
/** Chân một sự kiện: model gọn · thời lượng · chi phí ước tính (chỉ mục có thật; không có gì → ""). Không bao giờ có nội dung tin nhắn. */
export function chanSuKien(s: SuKienVclaw): string {
  const ra: string[] = [];
  const model = (s.model || (typeof s.meta.model === 'string' ? s.meta.model : '')).replace(/^claude-/, '').replace(/\[.*\]$/, '');
  if (model) ra.push(model);
  // `seconds` là khoá của sự kiện việc thường, `secs` là khoá của sự kiện agent_job (đội agent).
  const giay = typeof s.meta.seconds === 'number' ? s.meta.seconds : typeof s.meta.secs === 'number' ? s.meta.secs : null;
  if (giay !== null && giay >= 0) ra.push(thoiLuong(giay));
  if (typeof s.meta.cost === 'number' && s.meta.cost > 0) ra.push(`~${usd(s.meta.cost)}`);
  return ra.join(' · ');
}

/** Tên tiếng Việt của từng loại mục bộ nhớ (theo quy ước tiền tố note của hub). */
export const NHAN_BO_NHO: Record<LoaiBoNho, string> = {
  DEC: 'Quyết định', PAT: 'Cách hay', ANT: 'Cách sai đã trả giá', INC: 'Sự cố', SPEC: 'Hợp đồng', SESSION: 'Phiên làm việc', MEMORY: 'Ghi nhớ bền',
};
/** "2026-10-13" → "13/10/2026"; sai dạng / rỗng → "". */
export const ngayDayDu = (ngay: string): string => (/^\d{4}-\d{2}-\d{2}$/.test(ngay) ? `${ngay.slice(8, 10)}/${ngay.slice(5, 7)}/${ngay.slice(0, 4)}` : '');

// ── Biểu đồ token / chi phí: nhãn, thang trục, mô tả cho bàn đọc màn hình ──
export const CHI_SO_BIEU_DO: { ma: ChiSoBieuDo; ten: string; ten_ngan: string }[] = [
  { ma: 'token', ten: 'Token (vào + ra)', ten_ngan: 'Token' },
  { ma: 'chi-phi', ten: 'Chi phí ước tính (USD)', ten_ngan: 'Chi phí' },
  { ma: 'viec', ten: 'Số việc', ten_ngan: 'Số việc' },
];
/** Giá trị theo đúng chỉ số: token → "1,2M", chi phí → "$1,23", việc → "12". */
export function nhanGiaTri(chi_so: ChiSoBieuDo, v: number): string {
  if (!Number.isFinite(v)) return '—';
  return chi_so === 'chi-phi' ? usd(v) : chi_so === 'viec' ? String(Math.round(v)) : soGon(v);
}
/** Thang trục Y "đẹp" cho cột xếp chồng bắt đầu từ 0: bước 1·2·2,5·5·10 × 10^k, khoảng `so_moc` vạch; `hi` luôn ≥ `cao_nhat`.
 *  `nguyen` = chỉ số đếm (số việc): bước nguyên ≥ 1. Không có số liệu (≤ 0, NaN, vô cực) → 0…1 (hoặc 0…1 việc). */
export function thangTrucY(cao_nhat: number, so_moc = 4, nguyen = false): { hi: number; moc: number[] } {
  const max = Number.isFinite(cao_nhat) && cao_nhat > 0 ? cao_nhat : 0;
  if (max === 0) return { hi: 1, moc: [0, 1] };
  const n = Number.isFinite(so_moc) ? Math.min(20, Math.max(1, Math.floor(so_moc))) : 4;
  const tho = max / n;
  const mu = Math.max(nguyen ? 1 : 0, Math.pow(10, Math.floor(Math.log10(tho))));
  const bac = nguyen ? [1, 2, 5, 10] : [1, 2, 2.5, 5, 10];
  const buoc = bac.map((b) => b * mu).find((b) => b >= tho - 1e-12) ?? 10 * mu;
  const hi = Math.ceil(max / buoc - 1e-9) * buoc;
  const moc: number[] = [];
  for (let k = 0; k * buoc <= hi + buoc / 1000; k++) moc.push(Number((k * buoc).toPrecision(12)));
  return { hi: Number(hi.toPrecision(12)), moc };
}
/** Một câu mô tả cả biểu đồ cho bàn đọc màn hình: tổng + ngày cao nhất. Chưa có số liệu thì nói thẳng. */
export function tomTatBieuDo(chuoi: ChuoiBieuDo, chi_so: ChiSoBieuDo): string {
  const ten = (CHI_SO_BIEU_DO.find((c) => c.ma === chi_so)?.ten_ngan ?? 'Token').toLowerCase();
  const n = chuoi.ngay.length;
  if (!n || chuoi.cao_nhat <= 0) return `Biểu đồ cột ${ten} theo ngày, ${n} ngày gần nhất: chưa có số liệu.`;
  const tong = chuoi.tong_ngay.reduce((a, b) => a + b, 0);
  const i_max = chuoi.tong_ngay.indexOf(chuoi.cao_nhat);
  return `Biểu đồ cột ${ten} theo ngày, ${n} ngày gần nhất: tổng ${nhanGiaTri(chi_so, tong)}, cao nhất ngày ${ngayNgan(chuoi.ngay[i_max])} với ${nhanGiaTri(chi_so, chuoi.cao_nhat)}.`;
}
/** Mô tả MỘT cột (tooltip / vùng đọc cho bàn phím): "13/10: thanh@ith 800K, vgg@ith 400K — tổng 1,2M"; ngày VClaw không ghi gì → "…: không có số liệu". */
export function moTaNgayBieuDo(chuoi: ChuoiBieuDo, i: number, chi_so: ChiSoBieuDo): string {
  if (!Number.isInteger(i) || i < 0 || i >= chuoi.ngay.length) return '';
  const nhan = ngayNgan(chuoi.ngay[i]);
  if (!chuoi.ngay_chi_tiet[i]) return `${nhan}: không có số liệu`;
  const phan = chuoi.series.map((s, k) => ({ ten: s.ten, v: chuoi.gia_tri[i]?.[k] ?? 0 })).filter((p) => p.v > 0).map((p) => `${p.ten} ${nhanGiaTri(chi_so, p.v)}`);
  return `${nhan}: ${phan.length ? phan.join(', ') + ' — ' : ''}tổng ${nhanGiaTri(chi_so, chuoi.tong_ngay[i] ?? 0)}`;
}

// ── Chạy lại VClaw khi máy tắt: tình trạng + nội dung hướng dẫn (trang CHỈ hướng dẫn — không điều khiển được máy của chủ) ──
export type TinhTrangChayLai =
  | { muc: 'chua-co' }
  /** `tu` = lần cuối VClaw báo lên (`updated`), `phut` = đã im bao lâu; `nang` cam = chậm (≤ 3 giờ), đỏ = lâu hơn. */
  | { muc: 'khong-phan-hoi'; tu: string; phut: number; nang: 'cam' | 'do' }
  | { muc: 'dang-chay'; kieu: KieuChayVclaw; tuoi_phut: number | null };
/** Chưa có trạng thái → chua-co; im quá ngưỡng (45 phút — `vclawKhongPhanHoi`) → khong-phan-hoi; còn lại là đang chạy kèm cách chạy. */
export function tinhTrangChayLai(tt: TrangThaiVclaw | null, bay_gio: number): TinhTrangChayLai {
  if (!tt) return { muc: 'chua-co' };
  const phut = vclawKhongPhanHoi(tt.updated, bay_gio);
  if (phut !== null) return { muc: 'khong-phan-hoi', tu: tt.updated, phut, nang: phut > PHUT_CHAM ? 'do' : 'cam' };
  return { muc: 'dang-chay', kieu: kieuChayVclaw(tt.bridge.launch), tuoi_phut: tuoiPhut(tt.updated, bay_gio) };
}
/** Số phút im lặng → chữ: dưới 2 giờ giữ số phút ("95 phút"), từ 2 giờ trở đi gọn hơn ("3 giờ 5 phút"). */
export const thoiGianImLang = (phut: number): string => (phut < 120 ? `${Math.max(0, Math.round(phut))} phút` : thoiLuong(phut * 60));
/** Câu của banner khi VClaw không phản hồi. */
export const cauKhongPhanHoi = (tu_iso: string, phut: number): string =>
  `VClaw không phản hồi từ ${gioVaNgay(tu_iso)} (${thoiGianImLang(phut)}) — có thể máy PC đã tắt hoặc VClaw đã dừng`;

export type LenhChepDuoc = { nhan: string; lenh: string };
export type BuocChayLai = { so: number; tieu_de: string; mo_ta: string; lenh: LenhChepDuoc[] };
/** Ba bước đưa VClaw chạy lại. `lenh` là chữ thuần để chép vào PowerShell — KHÔNG chứa token / khoá / PIN nào. */
export const CAC_BUOC_CHAY_LAI: BuocChayLai[] = [
  {
    so: 1, tieu_de: 'Mở PowerShell',
    mo_ta: 'Bấm Start, gõ PowerShell rồi Enter. Dùng cửa sổ PowerShell riêng của bạn — KHÔNG phải cửa sổ nằm trong một phiên Claude.',
    lenh: [],
  },
  {
    so: 2, tieu_de: 'Gõ lệnh khởi động',
    mo_ta: 'Lần đầu lệnh này cài tác vụ nền của Windows rồi chạy VClaw, và chờ tới khi VClaw lên. Gõ lại bao nhiêu lần cũng được. Nếu PowerShell chưa nạp claude-acc (báo không nhận ra lệnh vclaw) thì dùng đường dẫn đầy đủ.',
    lenh: [
      { nhan: 'Lệnh khởi động', lenh: 'vclaw start' },
      { nhan: 'Nếu chưa nạp claude-acc', lenh: 'C:\\WORK\\UseAI\\scripts\\vclaw.cmd start' },
    ],
  },
  {
    so: 3, tieu_de: 'Kiểm tra',
    mo_ta: 'Dòng “chạy bằng” phải là ✅ tác vụ nền. Rồi nhắn thử cho bot trên Telegram.',
    lenh: [{ nhan: 'Lệnh kiểm tra', lenh: 'vclaw status' }],
  },
];
/** Ghi chú dưới ba bước. Chữ trong dấu ` là lệnh/đường dẫn (giao diện hiện dạng mã). Hai con số 30 là HAI khái niệm khác nhau: ghi chú 2 nói về
 *  tin nhắn cũ (telegram.stale_after_sec), ghi chú cuối nói về nhịp tim — vì thế trang chỉ báo "không phản hồi" sau 45 phút. */
export const GHI_CHU_CHAY_LAI: string[] = [
  'Đã đăng nhập Windows thì tác vụ nền tự chạy VClaw, và cứ 5 phút kiểm tra một lần — VClaw chết thì bật lại.',
  'Tin nhắn gửi lúc VClaw đang tắt quá 30 phút sẽ BỊ BỎ QUA (VClaw báo một lần “Bỏ qua N tin cũ”) — gửi lại nếu còn cần.',
  '`vclaw stop` là dừng có chủ ý: VClaw không tự bật lại cho tới khi bạn gõ `vclaw start`.',
  'Bot im sau khi đổi hồ sơ Claude thường là vì VClaw đang chạy trong một phiên Claude — gõ `vclaw restart` để chuyển sang tác vụ nền.',
  'Có lỗi: xem cuối tệp `%USERPROFILE%\\.vclaw\\vclaw.log`, hoặc chạy `vclaw doctor`.',
  'Trang web này chỉ hướng dẫn — không điều khiển được máy của bạn, và không bao giờ cần bạn nhập token vào đây.',
  'VClaw khi rảnh chỉ báo lên mỗi 30 phút (nhịp tim), nên trang chỉ báo “không phản hồi” sau 45 phút.',
];

// ═══════════ Trạm điều hành v3: sổ cái việc · quota theo thời gian · cảnh báo · tư thế bảo mật ═══════════
// Mọi hàm bên dưới THUẦN: không đọc đồng hồ (`bay_gio` luôn do nơi gọi truyền vào), không import react/api. Dữ liệu vào đã được server làm sạch
// (server/vclaw-kieu.ts) nhưng hàm vẫn chịu được mảng rỗng / thiếu trường — trang không bao giờ ném lỗi vì dữ liệu của VClaw.
const mangAnToan = <T>(v: readonly T[] | null | undefined): T[] => (Array.isArray(v) ? (v as T[]) : []);
const soSanhChu = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0);
const mocHuuHan = (bay_gio: number | undefined): number | null => (typeof bay_gio === 'number' && Number.isFinite(bay_gio) ? bay_gio : null);

// ── Lịch sử việc ──
/** Lý do việc không xong → nhãn tiếng Việt (nghĩa các loại lỗi theo scripts/vclaw/runner.py và bridge.py của repo UseAI). */
export const NHAN_LOI_VIEC: Record<LoaiLoiViec, string> = {
  rate_limit: 'Hết quota (giới hạn tốc độ)',
  seat_lost: 'Mất seat',
  login: 'Cần đăng nhập lại',
  timeout: 'Quá thời gian tối đa',
  idle: 'Im lặng quá lâu',
  quota_trip: 'Chạm ngưỡng quota',
  overloaded: 'Claude quá tải',
  no_session: 'Không tìm thấy phiên cũ',
  bad_model: 'Model không dùng được',
  context: 'Ngữ cảnh quá dài',
  cancelled: 'Bị dừng',
  crash: 'Tiến trình sập',
  unknown: 'Chưa rõ lý do',
};
/** "Xong" hoặc lý do lỗi bằng tiếng Việt. Lý do ngoài bảng (không xảy ra với dữ liệu đã làm sạch) → "Chưa rõ lý do". */
export function nhanKetQuaViec(v: Pick<ViecSoCai, 'ok' | 'kind'>): string {
  if (v.ok) return 'Xong';
  return Object.hasOwn(NHAN_LOI_VIEC, v.kind) ? NHAN_LOI_VIEC[v.kind as LoaiLoiViec] : NHAN_LOI_VIEC.unknown;
}
/** Công cụ dùng nhiều nhất của một việc, dạng "Bash ×5 · Read ×3" (tối đa `n`; không có công cụ nào → ""). */
export const congCuHangDau = (v: Pick<ViecSoCai, 'tools'>, n = 3): string => mangAnToan(v.tools).slice(0, Math.max(0, n)).map((c) => `${c.ten} ×${c.so}`).join(' · ');

export type ThongKeViecVclaw = {
  so_viec: number; so_xong: number; so_loi: number;
  /** % việc xong (0–100); không có việc nào → null */
  ty_le_thanh_cong: number | null;
  /** thời gian CHẠY (giây) của mọi việc, xong lẫn lỗi; trung vị thật (số chẵn thì lấy giữa hai số giữa) và p95 theo hạng gần nhất */
  trung_vi_giay: number | null; p95_giay: number | null;
  /** tổng chi phí USD ƯỚC TÍNH theo giá API */
  tong_chi_phi: number;
  /** token vào + ra (cùng định nghĩa với biểu đồ token) và token cache đọc + ghi (tách riêng) */
  tong_token: number; tong_cache: number;
  /** việc chạy lâu nhất / đắt nhất (null khi không việc nào có thời lượng / chi phí dương; hoà thì lấy việc MỚI hơn) */
  viec_lau_nhat: ViecSoCai | null; viec_dat_nhat: ViecSoCai | null;
};
const tgViec = (v: ViecSoCai) => Date.parse(v.ts);
export function thongKeViecVclaw(ds: ViecSoCai[]): ThongKeViecVclaw {
  const viec = mangAnToan(ds);
  const t: ThongKeViecVclaw = {
    so_viec: viec.length, so_xong: 0, so_loi: 0, ty_le_thanh_cong: null, trung_vi_giay: null, p95_giay: null,
    tong_chi_phi: 0, tong_token: 0, tong_cache: 0, viec_lau_nhat: null, viec_dat_nhat: null,
  };
  for (const v of viec) {
    if (v.ok) t.so_xong++; else t.so_loi++;
    t.tong_chi_phi += v.cost;
    t.tong_token += v.tok.in + v.tok.out;
    t.tong_cache += v.tok.cr + v.tok.cw;
    const lau = t.viec_lau_nhat, dat = t.viec_dat_nhat;
    if (v.secs > 0 && (!lau || v.secs > lau.secs || (v.secs === lau.secs && tgViec(v) > tgViec(lau)))) t.viec_lau_nhat = v;
    if (v.cost > 0 && (!dat || v.cost > dat.cost || (v.cost === dat.cost && tgViec(v) > tgViec(dat)))) t.viec_dat_nhat = v;
  }
  if (viec.length > 0) {
    t.ty_le_thanh_cong = (t.so_xong / viec.length) * 100;
    const giay = viec.map((v) => v.secs).sort((a, b) => a - b);
    const giua = giay.length >> 1;
    t.trung_vi_giay = giay.length % 2 === 1 ? giay[giua] : (giay[giua - 1] + giay[giua]) / 2;
    t.p95_giay = giay[Math.min(giay.length - 1, Math.max(0, Math.ceil(0.95 * giay.length) - 1))];
  }
  return t;
}

/** Kết quả để lọc: 'xong', 'loi' (mọi lý do) hoặc đúng một lý do (`kind`). */
export type KetQuaLocViec = 'xong' | 'loi' | LoaiLoiViec;
export type LocViecVclaw = { ket_qua?: KetQuaLocViec | null; ho_so?: string | null; model?: string | null };
/** Lọc việc theo kết quả / hồ sơ / model (khớp ĐÚNG chuỗi). Điều kiện trống = giữ hết; giữ nguyên thứ tự. */
export function locViecVclaw(ds: ViecSoCai[], loc: LocViecVclaw = {}): ViecSoCai[] {
  return mangAnToan(ds).filter((v) => {
    if (loc.ket_qua === 'xong' && !v.ok) return false;
    if (loc.ket_qua === 'loi' && v.ok) return false;
    if (loc.ket_qua && loc.ket_qua !== 'xong' && loc.ket_qua !== 'loi' && (v.ok || v.kind !== loc.ket_qua)) return false;
    if (loc.ho_so && v.profile !== loc.ho_so) return false;
    if (loc.model && v.model !== loc.model) return false;
    return true;
  });
}

export type LuaChonLocViec = {
  ho_so: { ten: string; so: number }[];
  model: { ten: string; so: number }[];
  /** lý do lỗi CÓ trong dữ liệu (nhiều việc nhất trước) */
  ly_do: { ma: LoaiLoiViec; so: number }[];
};
/** Các giá trị có thật trong dữ liệu để dựng ô chọn lọc: hồ sơ / model nhiều việc nhất trước (bỏ giá trị rỗng), lý do lỗi nhiều nhất trước. */
export function lietKeLocViec(ds: ViecSoCai[]): LuaChonLocViec {
  const ho_so = new Map<string, number>(), model = new Map<string, number>(), ly_do = new Map<LoaiLoiViec, number>();
  for (const v of mangAnToan(ds)) {
    if (v.profile) ho_so.set(v.profile, (ho_so.get(v.profile) ?? 0) + 1);
    if (v.model) model.set(v.model, (model.get(v.model) ?? 0) + 1);
    if (!v.ok) { const ma = Object.hasOwn(NHAN_LOI_VIEC, v.kind) ? (v.kind as LoaiLoiViec) : 'unknown'; ly_do.set(ma, (ly_do.get(ma) ?? 0) + 1); }
  }
  const xep = <K extends string>(m: Map<K, number>) => [...m].sort((a, b) => b[1] - a[1] || soSanhChu(a[0], b[0]));
  return {
    ho_so: xep(ho_so).map(([ten, so]) => ({ ten, so })),
    model: xep(model).map(([ten, so]) => ({ ten, so })),
    ly_do: xep(ly_do).map(([ma, so]) => ({ ma, so })),
  };
}

export type HoSoViecVclaw = { ho_so: string; so_viec: number; so_xong: number; so_loi: number; ty_le_thanh_cong: number; giay_trung_binh: number; chi_phi: number };
/** Độ tin cậy từng hồ sơ: số việc, % xong, thời gian chạy trung bình, chi phí ước tính. Nhiều việc nhất trước (hoà → theo tên). Tên rỗng gộp chung một dòng. */
export function theoHoSoViecVclaw(ds: ViecSoCai[]): HoSoViecVclaw[] {
  const m = new Map<string, { so_viec: number; so_xong: number; giay: number; chi_phi: number }>();
  for (const v of mangAnToan(ds)) {
    const c = m.get(v.profile) ?? { so_viec: 0, so_xong: 0, giay: 0, chi_phi: 0 };
    c.so_viec++;
    if (v.ok) c.so_xong++;
    c.giay += v.secs;
    c.chi_phi += v.cost;
    m.set(v.profile, c);
  }
  return [...m]
    .map(([ho_so, c]) => ({ ho_so, so_viec: c.so_viec, so_xong: c.so_xong, so_loi: c.so_viec - c.so_xong, ty_le_thanh_cong: (c.so_xong / c.so_viec) * 100, giay_trung_binh: c.giay / c.so_viec, chi_phi: c.chi_phi }))
    .sort((a, b) => b.so_viec - a.so_viec || soSanhChu(a.ho_so, b.ho_so));
}

// ── Quota theo thời gian ──
export const NHAN_KHOANG_QUOTA: Record<KhoangQuota, string> = { '6h': '6 giờ', '24h': '24 giờ', '7d': '7 ngày' };
/** Ba khoảng xem của biểu đồ quota, ngắn → dài, kèm độ dài (ms). */
export const CAC_KHOANG_QUOTA: { ma: KhoangQuota; ten: string; ms: number }[] = (Object.keys(KHOANG_QUOTA) as KhoangQuota[]).map((ma) => ({ ma, ten: NHAN_KHOANG_QUOTA[ma], ms: KHOANG_QUOTA[ma] }));

/** Ngưỡng quota mặc định của VClaw (đổi seat từ mức này) — dùng khi VClaw chưa báo `settings.quota`. */
export const NGUONG_QUOTA_MAC_DINH = 90;
const CUA_SO_DU_BAO_PHUT = 60;
const TOI_THIEU_MAU_DU_BAO = 3;
const TOI_THIEU_PHUT_DU_BAO = 10;
const TUOI_MAU_TOI_DA_PHUT = 30;
/** Dốc dưới mức này (điểm % mỗi giờ) coi như phẳng. */
const DOC_ON_DINH = 0.5;
/** Chạm ngưỡng xa hơn một cửa sổ 5 giờ thì dự báo vô nghĩa (quota đã hồi trước đó) → "ổn định". */
const TAM_DU_BAO_PHUT = 300;
/** Tụt ≥ chừng này điểm % giữa hai mẫu liền nhau = quota vừa hồi: dự báo chỉ dùng các mẫu sau lần tụt. */
const TUT_MANH = 10;

export type DuBaoQuota =
  /** chưa có ≥ 3 mẫu trải ≥ 10 phút trong 60 phút gần nhất, hoặc mẫu cuối quá cũ — KHÔNG đoán */
  | { loai: 'chua-du-mau'; so_mau: number }
  /** mẫu mới nhất đã ≥ ngưỡng (sự thật, không phải dự báo) */
  | { loai: 'da-vuot'; hien_tai: number }
  /** dốc phẳng hoặc đang giảm, hoặc chạm ngưỡng sau hơn 5 giờ */
  | { loai: 'on-dinh'; hien_tai: number; doc: number }
  /** theo đà này sẽ chạm ngưỡng: `luc` (epoch ms), `phut` còn lại (tính từ `bay_gio` nếu có, không thì từ mẫu cuối), `doc` điểm % mỗi giờ */
  | { loai: 'se-cham'; hien_tai: number; doc: number; phut: number; luc: number };

type DiemQuota = { t: number; v: number };
function diemQuotaHoSo(mau: MauQuota[], ho_so: string, truong: 'f' | 's'): DiemQuota[] {
  const ra: DiemQuota[] = [];
  for (const m of mangAnToan(mau)) {
    const t = Date.parse(m.ts);
    if (Number.isNaN(t)) continue;
    const p = mangAnToan(m.p).find((x) => x.n === ho_so);
    const v = p ? p[truong] : null;
    if (typeof v === 'number' && Number.isFinite(v)) ra.push({ t, v });
  }
  return ra.sort((a, b) => a.t - b.t);
}
/** Độ dốc bình phương tối thiểu, điểm % mỗi giờ (cần ≥ 2 điểm khác thời điểm, không thì 0). */
function docMoiGio(ds: DiemQuota[]): number {
  const n = ds.length;
  if (n < 2) return 0;
  const tb_t = ds.reduce((a, d) => a + d.t, 0) / n;
  const tb_v = ds.reduce((a, d) => a + d.v, 0) / n;
  let tu = 0, mau = 0;
  for (const d of ds) { const x = (d.t - tb_t) / 3_600_000; tu += x * (d.v - tb_v); mau += x * x; }
  return mau > 0 ? tu / mau : 0;
}
/** Dự báo khi nào quota 5 giờ của MỘT hồ sơ chạm `nguong`: độ dốc bình phương tối thiểu của ~60 phút gần nhất (tính từ mẫu cuối; một lần tụt mạnh = vừa hồi thì chỉ dùng
 *  các mẫu sau đó). KHÔNG đoán khi thiếu bằng chứng: cần ≥ 3 mẫu trải ≥ 10 phút, và mẫu cuối không cũ hơn 30 phút so với `bay_gio` (nếu truyền). */
export function phanTichDuBaoQuota(mau: MauQuota[], ho_so: string, nguong: number = NGUONG_QUOTA_MAC_DINH, bay_gio?: number): DuBaoQuota {
  const tat_ca = diemQuotaHoSo(mau, ho_so, 'f');
  const cuoi = tat_ca[tat_ca.length - 1];
  if (!cuoi) return { loai: 'chua-du-mau', so_mau: 0 };
  const moc = mocHuuHan(bay_gio);
  let cua_so = tat_ca.filter((d) => d.t >= cuoi.t - CUA_SO_DU_BAO_PHUT * 60_000);
  for (let i = cua_so.length - 1; i > 0; i--) {
    if (cua_so[i].v < cua_so[i - 1].v - TUT_MANH) { cua_so = cua_so.slice(i); break; }
  }
  if (moc !== null && moc - cuoi.t > TUOI_MAU_TOI_DA_PHUT * 60_000) return { loai: 'chua-du-mau', so_mau: cua_so.length };
  if (cuoi.v >= nguong) return { loai: 'da-vuot', hien_tai: cuoi.v };
  if (cua_so.length < TOI_THIEU_MAU_DU_BAO || (cuoi.t - cua_so[0].t) / 60_000 < TOI_THIEU_PHUT_DU_BAO) return { loai: 'chua-du-mau', so_mau: cua_so.length };
  const doc = docMoiGio(cua_so);
  if (doc < DOC_ON_DINH) return { loai: 'on-dinh', hien_tai: cuoi.v, doc };
  const phut_tu_mau = ((nguong - cuoi.v) / doc) * 60;
  if (phut_tu_mau > TAM_DU_BAO_PHUT) return { loai: 'on-dinh', hien_tai: cuoi.v, doc };
  const luc = cuoi.t + phut_tu_mau * 60_000;
  return { loai: 'se-cham', hien_tai: cuoi.v, doc, phut: Math.max(0, Math.round(moc !== null ? (luc - moc) / 60_000 : phut_tu_mau)), luc };
}
/** Số phút tới ngưỡng, hoặc null khi ổn định / đang giảm / thiếu mẫu (không đoán). Đã vượt ngưỡng → 0. Chi tiết (vì sao null) ở phanTichDuBaoQuota. */
export function duBaoQuota(mau: MauQuota[], ho_so: string, nguong: number = NGUONG_QUOTA_MAC_DINH, bay_gio?: number): number | null {
  const d = phanTichDuBaoQuota(mau, ho_so, nguong, bay_gio);
  return d.loai === 'se-cham' ? d.phut : d.loai === 'da-vuot' ? 0 : null;
}

export type GoiYHoSo = {
  name: string; seat: boolean; order: number;
  /** % đang dùng HIỆU LỰC: cửa sổ đã qua giờ hồi (so với `bay_gio`) tính 0; null = chưa đo */
  five: number | null; seven: number | null;
  da_hoi_5h: boolean; da_hoi_7d: boolean;
  /** cao hơn của hai cửa sổ; null = chưa đo được cửa sổ nào */
  muc_dung: number | null;
};
function hieuLuc(pct: number | null, reset: number | null, moc: number | null): { v: number | null; da_hoi: boolean } {
  if (pct === null || !Number.isFinite(pct)) return { v: null, da_hoi: false };
  if (moc !== null && reset !== null && Number.isFinite(reset) && reset * 1000 <= moc) return { v: 0, da_hoi: true };
  return { v: pct, da_hoi: false };
}
/** Hồ sơ nên dùng tiếp theo: bỏ hồ sơ cần đăng nhập, xếp theo mức dùng CAO HƠN của hai cửa sổ (5 giờ / 7 ngày) từ thấp đến cao; hồ sơ chưa đo được xếp sau cùng;
 *  hoà → theo thứ tự xoay seat rồi theo tên. Trả CẢ danh sách (nơi gọi chọn phần tử đầu không giữ seat). Truyền `bay_gio` để cửa sổ đã hồi tính là 0%. */
export function goiYHoSoTiepTheo(profiles: HoSoVclaw[], bay_gio?: number): GoiYHoSo[] {
  const moc = mocHuuHan(bay_gio);
  return mangAnToan(profiles)
    .filter((h) => h.login_ok)
    .map((h): GoiYHoSo => {
      const a = hieuLuc(h.five_pct, h.five_reset, moc), b = hieuLuc(h.seven_pct, h.seven_reset, moc);
      const co = [a.v, b.v].filter((x): x is number => x !== null);
      return { name: h.name, seat: h.seat, order: h.order, five: a.v, seven: b.v, da_hoi_5h: a.da_hoi, da_hoi_7d: b.da_hoi, muc_dung: co.length ? Math.max(...co) : null };
    })
    .sort((x, y) => {
      if ((x.muc_dung === null) !== (y.muc_dung === null)) return x.muc_dung === null ? 1 : -1;
      return (x.muc_dung ?? 0) - (y.muc_dung ?? 0) || x.order - y.order || soSanhChu(x.name, y.name);
    });
}

// ── Cảnh báo ──
/** Mã cảnh báo SUY RA phía trình duyệt. Bốn mã đầu TRÙNG đúng mã VClaw tự ghi cho cùng điều kiện (scripts/vclaw/alerts.py, docs/vclaw.md §Cảnh báo)
 *  để trang khử trùng theo `id` (mục của VClaw thắng, không hiện hai thẻ cho một việc). `vclaw-khong-phan-hoi` chỉ phía trang suy ra được:
 *  VClaw không tự báo được là mình đã chết. */
export const ID_CANH_BAO = {
  khong_phan_hoi: 'vclaw-khong-phan-hoi',
  het_quota: 'quota-all-high',
  can_dang_nhap: 'login-expired',
  chua_dat_pin: 'no-pin',
  duoi_phien_claude: 'under-claude',
} as const;
export type CanhBaoHienThi = CanhBaoVclaw & { nguon: 'vclaw' | 'suy-ra' };
const THU_TU_MUC_CANH_BAO: Record<CanhBaoVclaw['level'], number> = { crit: 0, warn: 1, info: 2 };
export const NHAN_MUC_CANH_BAO: Record<CanhBaoVclaw['level'], string> = { crit: 'Nghiêm trọng', warn: 'Cần chú ý', info: 'Thông tin' };

/** Cảnh báo để hiện đầu trang = `alerts` của VClaw + cảnh báo SUY RA từ trạng thái (không phản hồi ≥ 45 phút, mọi hồ sơ dùng được vượt ngưỡng hoặc VClaw đang chờ quota,
 *  có hồ sơ cần đăng nhập, chưa đặt PIN, chạy dưới phiên Claude). Khử trùng theo `id` (mục của VClaw thắng). Xếp: nghiêm trọng → cần chú ý → thông tin; cùng mức: bắt đầu MỚI hơn
 *  trước (mục không có thời điểm xuống cuối), rồi theo id. Chưa có trạng thái → rỗng. */
export function canhBaoHienThi(tt: TrangThaiVclaw | null, bay_gio: number): CanhBaoHienThi[] {
  if (!tt) return [];
  const ra = new Map<string, CanhBaoHienThi>();
  for (const c of mangAnToan(tt.alerts)) if (!ra.has(c.id)) ra.set(c.id, { ...c, nguon: 'vclaw' });
  const them = (c: CanhBaoVclaw) => { if (!ra.has(c.id)) ra.set(c.id, { ...c, nguon: 'suy-ra' }); };

  const im_lang = vclawKhongPhanHoi(tt.updated, bay_gio);
  if (im_lang !== null) {
    them({
      id: ID_CANH_BAO.khong_phan_hoi, level: im_lang > PHUT_CHAM ? 'crit' : 'warn', since: tt.updated, text: cauKhongPhanHoi(tt.updated, im_lang),
      hint: 'Làm theo mục “Chạy lại VClaw khi máy tắt” ngay bên dưới: mở một cửa sổ PowerShell riêng rồi gõ `vclaw start`.',
    });
  }

  const ho_so = mangAnToan(tt.profiles);
  const nguong_5h = tt.settings?.quota.threshold_5h ?? NGUONG_QUOTA_MAC_DINH;
  const nguong_7d = tt.settings?.quota.threshold_7d ?? NGUONG_QUOTA_MAC_DINH;
  const dung_duoc = ho_so.filter((h) => h.login_ok);
  const vuot = (h: HoSoVclaw) => {
    const a = hieuLuc(h.five_pct, h.five_reset, mocHuuHan(bay_gio)), b = hieuLuc(h.seven_pct, h.seven_reset, mocHuuHan(bay_gio));
    return (a.v !== null && a.v >= nguong_5h) || (b.v !== null && b.v >= nguong_7d);
  };
  const cho_den = tt.blocked_until && Date.parse(tt.blocked_until) > bay_gio ? tt.blocked_until : null;
  if (cho_den || (dung_duoc.length > 0 && dung_duoc.every(vuot))) {
    them({
      id: ID_CANH_BAO.het_quota, level: 'crit', since: '',
      text: cho_den
        ? `Không còn hồ sơ nào còn quota — VClaw chờ tới ${gioVaNgay(cho_den)} rồi tự chạy tiếp`
        : `Mọi hồ sơ dùng được đều đang vượt ngưỡng quota (5 giờ từ ${nguong_5h}% hoặc 7 ngày từ ${nguong_7d}%)`,
      hint: 'Việc mới phải chờ quota hồi. Xem “Quota theo thời gian” để biết hồ sơ nào hồi trước, hoặc đăng nhập thêm một hồ sơ.',
    });
  }

  const can_dang_nhap = ho_so.filter((h) => !h.login_ok);
  if (can_dang_nhap.length > 0) {
    const ten = can_dang_nhap.slice(0, 3).map((h) => h.name).join(', ') + (can_dang_nhap.length > 3 ? `, … (+${can_dang_nhap.length - 3})` : '');
    them({
      id: ID_CANH_BAO.can_dang_nhap, level: 'warn', since: '',
      text: `${can_dang_nhap.length} hồ sơ cần đăng nhập lại: ${ten}`,
      hint: 'Đăng nhập lại hồ sơ đó trên máy chạy VClaw (lệnh `claude-acc`); hồ sơ chưa đăng nhập không nhận được việc.',
    });
  }

  const pin = tt.security?.posture.pin ?? tt.settings?.security.pin_set ?? null;
  if (pin === false) {
    them({
      id: ID_CANH_BAO.chua_dat_pin, level: 'warn', since: '',
      text: 'Chưa đặt PIN — bot không tự khoá khi không dùng',
      hint: 'Đặt PIN theo mục bảo mật trong docs/vclaw.md (repo UseAI), rồi gõ `vclaw restart`.',
    });
  }

  if (tt.bridge.launch?.under_claude === true) {
    them({
      id: ID_CANH_BAO.duoi_phien_claude, level: 'warn', since: '',
      text: 'VClaw đang chạy trong một phiên Claude — sẽ dừng khi đổi hồ sơ',
      hint: 'Gõ `vclaw restart` trong một cửa sổ PowerShell riêng để chuyển sang tác vụ nền Windows.',
    });
  }

  const gio = (c: CanhBaoVclaw) => { const t = Date.parse(c.since); return Number.isNaN(t) ? -Infinity : t; };
  return [...ra.values()].sort((a, b) => THU_TU_MUC_CANH_BAO[a.level] - THU_TU_MUC_CANH_BAO[b.level] || gio(b) - gio(a) || soSanhChu(a.id, b.id));
}

// ── Bảo mật và độ sẵn sàng ──
export type MucTheBaoMat = 'tot' | 'can-chu-y' | 'chua-ro';
export type MaTheBaoMat = 'pin' | 'kill_phrase' | 'permission_mode' | 'mcp' | 'disallowed_tools' | 'redact' | 'stale_after_sec';
export type DongTheBaoMat = {
  ma: MaTheBaoMat; nhan: string; muc: MucTheBaoMat;
  /** giá trị đang đặt, dạng chữ ("Đã đặt", "auto", "5 công cụ"…) */
  gia_tri: string;
  /** vì sao mục này quan trọng / rủi ro gì */
  ghi_chu: string;
  /** việc nên làm; rỗng khi mục đã tốt */
  viec_nen_lam: string;
};
const CHE_DO_QUYEN_AN_TOAN = ['acceptEdits', 'manual', 'dontAsk', 'plan'];
const CHUA_RO_VIEC = 'VClaw bản này chưa báo mục này — cập nhật repo UseAI rồi gõ `vclaw restart`.';

/** Tư thế bảo mật (PIN, cụm từ dừng khẩn, chế độ quyền, MCP, công cụ bị chặn, che bí mật, ngưỡng tin cũ). Nguồn: `security.posture` (v3), thiếu thì lấy `settings` (v2) cho các mục
 *  trùng. Không có cả hai → [] (nơi gọi hiện trạng thái rỗng "VClaw chưa báo"). Mục không biết → 'chua-ro', KHÔNG bao giờ báo tốt khi không có bằng chứng. */
export function tuThePosture(tt: TrangThaiVclaw | null): DongTheBaoMat[] {
  const bm = tt?.security ?? null, cd = tt?.settings ?? null;
  if (!tt || (!bm && !cd)) return [];
  const p = bm?.posture;
  const pin = p?.pin ?? cd?.security.pin_set ?? null;
  const cum_tu = p?.kill_phrase ?? cd?.security.kill_phrase_set ?? null;
  const che_do = p?.permission_mode || cd?.permission_mode || '';
  const mcp = p?.mcp || cd?.mcp || '';
  const cong_cu_cam = p?.disallowed_tools ?? cd?.disallowed_tools ?? null;
  const che_bi_mat = p?.redact ?? cd?.chatlog.redact ?? null;
  const tin_cu = p?.stale_after_sec ?? null;
  const dong = (ma: MaTheBaoMat, nhan: string, muc: MucTheBaoMat, gia_tri: string, ghi_chu: string, viec_nen_lam = ''): DongTheBaoMat => ({ ma, nhan, muc, gia_tri, ghi_chu, viec_nen_lam });

  const ra: DongTheBaoMat[] = [];
  ra.push(pin === true
    ? dong('pin', 'PIN khoá bot', 'tot', 'Đã đặt', 'Bot tự khoá khi không dùng; phải nhập PIN mới giao việc được.')
    : pin === false
      ? dong('pin', 'PIN khoá bot', 'can-chu-y', 'Chưa đặt', 'Không có PIN thì người được phép nhắn bot giao việc ngay, kể cả khi điện thoại bị người khác cầm.', 'Đặt PIN theo mục bảo mật trong docs/vclaw.md (repo UseAI), rồi gõ `vclaw restart`.')
      : dong('pin', 'PIN khoá bot', 'chua-ro', '—', 'Bot tự khoá khi không dùng nếu đã đặt PIN.', CHUA_RO_VIEC));
  ra.push(cum_tu === true
    ? dong('kill_phrase', 'Cụm từ dừng khẩn', 'tot', 'Đã đặt', 'Gửi cụm từ này từ Telegram là VClaw dừng ngay, kể cả khi đang khoá.')
    : cum_tu === false
      ? dong('kill_phrase', 'Cụm từ dừng khẩn', 'can-chu-y', 'Chưa đặt', 'Không có cách dừng VClaw ngay từ điện thoại khi nó chạy sai hướng.', 'Đặt một cụm từ dừng khẩn trong cấu hình VClaw (mục bảo mật), rồi gõ `vclaw restart`.')
      : dong('kill_phrase', 'Cụm từ dừng khẩn', 'chua-ro', '—', 'Gửi cụm từ này từ Telegram là VClaw dừng ngay.', CHUA_RO_VIEC));
  if (!che_do) {
    ra.push(dong('permission_mode', 'Chế độ quyền', 'chua-ro', '—', 'Quyết định Claude có tự chạy lệnh mà không hỏi ai hay không.', CHUA_RO_VIEC));
  } else if (che_do === 'bypassPermissions') {
    ra.push(dong('permission_mode', 'Chế độ quyền', 'can-chu-y', che_do, 'RỦI RO CAO: mọi tin Telegram chạy lệnh KHÔNG qua kiểm duyệt nào.', 'Đổi `claude.permission_mode` về `auto` hoặc chặt hơn, trừ khi bạn thật sự cần.'));
  } else if (che_do === 'auto') {
    ra.push(dong(
      'permission_mode', 'Chế độ quyền', 'can-chu-y', che_do,
      'Rủi ro: Claude tự chạy lệnh theo bộ phân loại tự động của Claude Code — không ai bấm duyệt từng lệnh. Chỉ chấp nhận được khi đã có PIN, đã chặn công cụ nguy hiểm và chỉ đúng người của bạn nhắn được bot.',
      'Giữ nguyên chỉ khi PIN đã đặt và công cụ nguy hiểm đã bị chặn; muốn chặt hơn thì đổi `claude.permission_mode` sang `acceptEdits` hoặc `plan`.',
    ));
  } else if (CHE_DO_QUYEN_AN_TOAN.includes(che_do)) {
    ra.push(dong('permission_mode', 'Chế độ quyền', 'tot', che_do, 'Lệnh nhạy cảm không tự chạy: việc cần hỏi sẽ bị từ chối hoặc chờ duyệt.'));
  } else {
    ra.push(dong('permission_mode', 'Chế độ quyền', 'chua-ro', che_do, 'Chế độ này VTask chưa biết — kiểm tra trong cấu hình VClaw.', 'Chạy `vclaw doctor` để xem VClaw đánh giá chế độ này thế nào.'));
  }
  if (!mcp) {
    ra.push(dong('mcp', 'MCP', 'chua-ro', '—', 'MCP mở thêm đường ra ngoài (mạng, tài khoản) cho Claude.', CHUA_RO_VIEC));
  } else if (mcp === 'all') {
    ra.push(dong('mcp', 'MCP', 'can-chu-y', 'Nạp mọi MCP của hồ sơ', 'Mỗi MCP là thêm một đường ra ngoài cho agent chạy từ Telegram.', 'Đặt `claude.mcp = none`, hoặc trỏ tới một tệp MCP riêng chỉ chứa đúng thứ cần.'));
  } else if (mcp === 'none') {
    ra.push(dong('mcp', 'MCP', 'tot', 'Không nạp MCP', 'Agent chạy từ Telegram không có công cụ MCP nào ngoài các công cụ có sẵn.'));
  } else {
    ra.push(dong('mcp', 'MCP', 'tot', 'Chỉ nạp từ tệp riêng', 'Chỉ nạp đúng các MCP liệt kê trong tệp bạn chỉ định.'));
  }
  ra.push(cong_cu_cam === null
    ? dong('disallowed_tools', 'Công cụ bị chặn', 'chua-ro', '—', 'Danh sách công cụ agent chạy từ Telegram KHÔNG được dùng.', CHUA_RO_VIEC)
    : cong_cu_cam > 0
      ? dong('disallowed_tools', 'Công cụ bị chặn', 'tot', `${cong_cu_cam} công cụ`, 'Các công cụ này agent chạy từ Telegram không dùng được.')
      : dong('disallowed_tools', 'Công cụ bị chặn', 'can-chu-y', 'Chưa chặn công cụ nào', 'Agent chạy từ Telegram dùng được mọi công cụ, kể cả đọc thư mục bí mật của VClaw.', 'Đặt `claude.disallowed_tools` trong cấu hình VClaw (mặc định đã chặn thư mục bí mật).'));
  ra.push(che_bi_mat === true
    ? dong('redact', 'Che bí mật khi đẩy lên ChatLog', 'tot', 'Bật', 'Token / khoá lỡ lọt vào tin nhắn sẽ bị che trước khi lên repo ChatLog.')
    : che_bi_mat === false
      ? dong('redact', 'Che bí mật khi đẩy lên ChatLog', 'can-chu-y', 'Tắt', 'Bí mật lỡ lọt vào tin nhắn sẽ nằm nguyên văn trên repo ChatLog.', 'Đặt `chatlog.redact = true` trong cấu hình VClaw, rồi gõ `vclaw restart`.')
      : dong('redact', 'Che bí mật khi đẩy lên ChatLog', 'chua-ro', '—', 'Token / khoá lỡ lọt vào tin nhắn có bị che trước khi lên repo ChatLog hay không.', CHUA_RO_VIEC));
  ra.push(tin_cu === null
    ? dong('stale_after_sec', 'Ngưỡng tin cũ', 'chua-ro', '—', 'Tin nhắn gửi lúc VClaw tắt mà cũ hơn mức này sẽ không tự chạy khi VClaw bật lại.', CHUA_RO_VIEC)
    : tin_cu > 0
      ? dong('stale_after_sec', 'Ngưỡng tin cũ', 'tot', thoiLuong(tin_cu), 'Tin cũ hơn mức này bị bỏ qua (VClaw báo một lần) thay vì tự chạy lại khi bật lên.')
      : dong('stale_after_sec', 'Ngưỡng tin cũ', 'can-chu-y', 'Không bỏ qua tin cũ', 'Tin nhắn gửi lúc VClaw tắt sẽ chạy hết khi VClaw bật lại — kể cả lệnh bạn đã quên.', 'Đặt `telegram.stale_after_sec` (mặc định 1800 giây) trong cấu hình VClaw.'));
  return ra;
}

export type DongDemBaoMat = {
  ma: 'blocked_today' | 'unlock_fail_today' | 'lockouts_today' | 'stale_skipped_today' | 'kills_7d';
  nhan: string;
  /** null = VClaw không ghi (khác 0 = ghi và bằng 0) */
  so: number | null;
  ky: 'hom-nay' | '7-ngay';
  /** loại sự kiện của Hive mind tương ứng (để liên kết lọc) */
  loc: LoaiSuKien;
};
/** Năm số đếm bảo mật (bốn số của hôm nay + dừng khẩn 7 ngày), luôn đủ năm dòng khi VClaw có báo `security`; chưa báo → []. */
export function dongDemBaoMat(bm: BaoMatVclaw | null): DongDemBaoMat[] {
  if (!bm) return [];
  return [
    { ma: 'blocked_today', nhan: 'Người lạ nhắn bot', so: bm.blocked_today, ky: 'hom-nay', loc: 'alert' },
    { ma: 'unlock_fail_today', nhan: 'Nhập sai PIN', so: bm.unlock_fail_today, ky: 'hom-nay', loc: 'unlock' },
    { ma: 'lockouts_today', nhan: 'Bị khoá cứng', so: bm.lockouts_today, ky: 'hom-nay', loc: 'lock' },
    { ma: 'stale_skipped_today', nhan: 'Tin cũ bị bỏ qua', so: bm.stale_skipped_today, ky: 'hom-nay', loc: 'stale' },
    { ma: 'kills_7d', nhan: 'Dừng khẩn', so: bm.kills_7d, ky: '7-ngay', loc: 'kill' },
  ];
}

export type DoSanSangHienThi = {
  /** lúc VClaw khởi động (uptime.started, thiếu thì bridge.started); '' = không rõ */
  khoi_dong: string;
  /** số lần khởi động lại trong 24 giờ; null = không ghi. ≥ 3 coi là bất thường. */
  khoi_dong_lai: number | null;
  khoi_dong_lai_nhieu: boolean;
  nhip_tim_moi_giay: number | null;
  /** tuổi nhịp tim (phút): lần VClaw báo sống gần nhất (bridge.alive, thiếu thì `updated`); null = không rõ */
  tuoi_nhip_tim_phut: number | null;
  /** số lần khởi động trong 7 ngày qua, KỂ CẢ lần hiện tại (1 = chưa khởi động lại lần nào); null = VClaw (bản cũ) chưa ghi */
  khoi_dong_lai_7n: number | null;
  /** khoảng DỪNG dài nhất (giây) giữa một lần dừng êm và lần chạy lại trong 7 ngày; null = chưa có số (xem `vclaw_ghi_quang_dung` để biết vì sao) */
  quang_dung_dai_nhat_giay: number | null;
  /** VClaw CÓ ghi khoá quãng dừng (kể cả khi giá trị là null = bản mới nhưng chưa đo được lần dừng êm nào). false = VClaw bản cũ không có khoá này → cập nhật VClaw. */
  vclaw_ghi_quang_dung: boolean;
};
/** Khối "độ sẵn sàng": gộp `uptime` (v3) với `bridge` (v2) để bản VClaw cũ vẫn có "khởi động lúc" và "tuổi nhịp tim". */
export function doSanSangHienThi(tt: TrangThaiVclaw | null, bay_gio: number): DoSanSangHienThi | null {
  if (!tt) return null;
  const u = tt.uptime;
  const nhip = tt.bridge.alive || tt.updated;
  return {
    khoi_dong: u?.started || tt.bridge.started || '',
    khoi_dong_lai: u?.restarts_24h ?? null,
    khoi_dong_lai_nhieu: (u?.restarts_24h ?? 0) >= 3,
    nhip_tim_moi_giay: u?.heartbeat_every_sec ?? null,
    tuoi_nhip_tim_phut: nhip ? tuoiPhut(nhip, bay_gio) : null,
    khoi_dong_lai_7n: u?.restarts_7d ?? null,
    quang_dung_dai_nhat_giay: u?.longest_gap_sec_7d ?? null,
    vclaw_ghi_quang_dung: u?.longest_gap_sec_7d !== undefined,
  };
}

export type TienDoNganSach = {
  /** có ngân sách mềm (`daily_usd_soft` > 0) để vẽ thanh tiến độ */
  co: boolean;
  han_muc: number | null; da_chi: number | null;
  /** % đã dùng (có thể > 100); VClaw không ghi thì tự tính từ da_chi / han_muc; không tính được → null */
  pct: number | null;
  muc: 'tot' | 'chu-y' | 'vuot';
};
/** Ngân sách ngày MỀM: chỉ vẽ thanh khi `daily_usd_soft` > 0 (0 / thiếu = không đặt ngân sách). Chi phí luôn là ƯỚC TÍNH theo giá API. */
export function tienDoNganSach(b: NganSachVclaw | null): TienDoNganSach {
  const han_muc = b?.daily_usd_soft ?? null, da_chi = b?.spent_today ?? null;
  const co = han_muc !== null && han_muc > 0;
  const tu_tinh = co && da_chi !== null ? (da_chi / (han_muc as number)) * 100 : null;
  const pct = co ? (b?.pct ?? tu_tinh) : null;
  return { co, han_muc, da_chi, pct, muc: pct !== null && pct >= 100 ? 'vuot' : pct !== null && pct >= 80 ? 'chu-y' : 'tot' };
}

// ── Biểu đồ quota theo thời gian: dựng chuỗi đường, mốc trục thời gian, câu mô tả (hàm thuần; đồ thị SVG vẽ ở views/vclaw/QuotaTheoThoiGian.tsx) ──
export type ChiSoQuota = '5h' | '7d';
/** Hai cửa sổ quota của Claude: 5 giờ (trường `f` của mẫu) và 7 ngày (trường `s`). */
export const CAC_CHI_SO_QUOTA: { ma: ChiSoQuota; ten: string; ten_ngan: string }[] = [
  { ma: '5h', ten: 'Quota 5 giờ', ten_ngan: 'Cửa sổ 5 giờ' },
  { ma: '7d', ten: 'Quota 7 ngày', ten_ngan: 'Cửa sổ 7 ngày' },
];
/** Các vạch ngang của trục % (trục luôn 0–100: quota là phần trăm thật, không cắt trục) và vạch "gần hết" cố định. */
export const MOC_TRUC_QUOTA = [0, 25, 50, 75, 100] as const;
export const NGUONG_QUOTA_GAN_HET = 95;
/** Hai mẫu liền nhau cách nhau hơn mức này (và hơn 4 lần khoảng cách thường gặp) thì đường ĐỨT thay vì nối thẳng — không vẽ như thể có số liệu ở chỗ trống. */
const KHE_DUT_TOI_THIEU_MS = 45 * 60_000;

/** Thứ tự hồ sơ ỔN ĐỊNH để gán màu: trước hết `uu_tien` (nơi gọi truyền cùng thứ tự với biểu đồ token để mỗi hồ sơ giữ ĐÚNG MỘT màu ở cả hai biểu đồ),
 *  rồi các hồ sơ chỉ có trong mẫu quota theo ABC. Trùng tên giữ lần đầu; không đổi mảng vào. */
export function thuTuHoSoQuota(mau: MauQuota[], uu_tien: string[] = []): string[] {
  const ra: string[] = [];
  const co = new Set<string>();
  for (const t of mangAnToan(uu_tien)) if (typeof t === 'string' && t && !co.has(t)) { co.add(t); ra.push(t); }
  const them = new Set<string>();
  for (const m of mangAnToan(mau)) for (const p of mangAnToan(m?.p)) if (p?.n && !co.has(p.n)) them.add(p.n);
  return [...ra, ...[...them].sort(soSanhChu)];
}

/** Một lần đo của MỘT hồ sơ: % (null = lần đó không đo được / hồ sơ không có mặt) và có đang giữ seat không. */
export type DiemChuoiQuota = { v: number | null; seat: boolean };
export type SeriesQuota = {
  ten: string;
  /** vị trí màu 0…5 (khớp --chuoi-1…6, cùng thứ tự với biểu đồ token); null = xám chung khi hết màu */
  slot: number | null;
  /** diem[k] ứng với thoi_diem[k] của chuỗi */
  diem: DiemChuoiQuota[];
  /** lần đo cuối có mặt của hồ sơ này: có giữ seat không / đăng nhập còn ổn không */
  seat_cuoi: boolean;
  can_dang_nhap: boolean;
  /** giá trị số gần nhất (series không có số nào thì bị bỏ nên luôn có giá trị) */
  gia_tri_cuoi: number | null;
};
export type ChuoiQuota = {
  chi_so: ChiSoQuota;
  /** miền thời gian của trục x (epoch ms): [den − khoảng, den], den = max(bay_gio, mẫu cuối) */
  tu: number; den: number;
  /** thời điểm các lần đo trong miền, tăng dần, không trùng */
  thoi_diem: number[];
  series: SeriesQuota[];
  /** hồ sơ có trong mẫu nhưng CHƯA lần nào đo được chỉ số này */
  chua_do: string[];
  /** số hồ sơ phải dùng màu xám chung vì hết 6 màu */
  so_ho_so_gop: number;
  khe_toi_da_ms: number;
};

/** Mẫu quota (cũ → mới, đã làm sạch) → chuỗi cho biểu đồ đường của MỘT chỉ số. `khoang_ms` = độ dài miền xem; `bay_gio` = mép phải của trục (không sớm hơn mẫu cuối).
 *  Series = mỗi hồ sơ có ÍT NHẤT MỘT số của chỉ số này; màu theo vị trí trong `thuTuHoSoQuota(mau, thu_tu)` nên không đổi khi đổi khoảng xem hay đổi chỉ số. */
export function chuoiQuota(mau: MauQuota[], khoang_ms: number, bay_gio: number, chi_so: ChiSoQuota, thu_tu: string[] = []): ChuoiQuota {
  const truong = chi_so === '7d' ? 's' : 'f';
  const co_gio = mangAnToan(mau).filter((m) => m && typeof m === 'object').map((m) => ({ m, t: Date.parse(m.ts) })).filter((x) => Number.isFinite(x.t)).sort((a, b) => a.t - b.t);
  const khong_trung = co_gio.filter((x, i) => i === 0 || x.t !== co_gio[i - 1].t);
  const cuoi = khong_trung.length ? khong_trung[khong_trung.length - 1].t : null;
  const moc = mocHuuHan(bay_gio) ?? cuoi ?? 0;
  const den = cuoi !== null ? Math.max(moc, cuoi) : moc;
  const dai = Number.isFinite(khoang_ms) && khoang_ms > 0 ? khoang_ms : KHOANG_QUOTA['24h'];
  const tu = den - dai;
  const trong = khong_trung.filter((x) => x.t >= tu);
  const thoi_diem = trong.map((x) => x.t);

  const khoang_cach = thoi_diem.slice(1).map((t, i) => t - thoi_diem[i]).sort((a, b) => a - b);
  const trung_vi = khoang_cach.length ? khoang_cach[khoang_cach.length >> 1] : 0;
  const khe_toi_da_ms = Math.max(KHE_DUT_TOI_THIEU_MS, 4 * trung_vi);

  const series: SeriesQuota[] = [];
  const chua_do: string[] = [];
  let so_ho_so_gop = 0;
  thuTuHoSoQuota(trong.map((x) => x.m), thu_tu).forEach((ten, vi_tri) => {
    const lan_do = trong.map(({ m }) => mangAnToan(m.p).find((p) => p?.n === ten));
    if (lan_do.every((p) => !p)) return; // chỉ có ở `thu_tu` (không có trong mẫu): giữ chỗ màu, không có đường
    const diem = lan_do.map((p): DiemChuoiQuota => {
      const v = p ? p[truong] : null;
      return { v: typeof v === 'number' && Number.isFinite(v) ? v : null, seat: p?.seat === true };
    });
    const co_so = diem.filter((d) => d.v !== null);
    if (co_so.length === 0) { chua_do.push(ten); return; }
    const p_cuoi = [...lan_do].reverse().find((p) => p)!;
    const slot = vi_tri < TOI_DA_MAU_HO_SO ? vi_tri : null;
    if (slot === null) so_ho_so_gop++;
    series.push({ ten, slot, diem, seat_cuoi: p_cuoi.seat === true, can_dang_nhap: p_cuoi.ok === false, gia_tri_cuoi: co_so[co_so.length - 1].v });
  });
  return { chi_so, tu, den, thoi_diem, series, chua_do, so_ho_so_gop, khe_toi_da_ms };
}

/** Đường vẽ của MỘT hồ sơ (chuỗi `d` của SVG path): `nen` = mọi đoạn nối được (nét mảnh), `dam` = các đoạn mà hồ sơ ĐANG GIỮ SEAT ở đầu đoạn (vẽ chồng, nét đậm),
 *  `le` = điểm đứng một mình (đường đứt hai bên) để vẫn thấy được. Không nối qua lần không đo (null) hay qua khe hơn `khe_toi_da_ms`. */
export function veDuongQuota(
  s: SeriesQuota, thoi_diem: number[], toa_do: { x: (t: number) => number; y: (v: number) => number }, khe_toi_da_ms: number,
): { nen: string; dam: string; le: { x: number; y: number }[] } {
  const so = (n: number) => String(Math.round(n * 10) / 10);
  let nen = '', dam = '';
  const le: { x: number; y: number }[] = [];
  let truoc: { x: number; y: number; t: number; seat: boolean } | null = null;
  let do_dai_doan = 0;
  const ket_thuc_doan = () => { if (do_dai_doan === 1 && truoc) le.push({ x: truoc.x, y: truoc.y }); truoc = null; do_dai_doan = 0; };
  const n = Math.min(s.diem.length, thoi_diem.length);
  for (let i = 0; i < n; i++) {
    const d = s.diem[i];
    if (d.v === null) { ket_thuc_doan(); continue; }
    const t = thoi_diem[i];
    const x = toa_do.x(t), y = toa_do.y(d.v);
    if (truoc && t - truoc.t <= khe_toi_da_ms) {
      nen += `L${so(x)} ${so(y)}`;
      if (truoc.seat) dam += `M${so(truoc.x)} ${so(truoc.y)}L${so(x)} ${so(y)}`;
      do_dai_doan++;
    } else {
      ket_thuc_doan();
      nen += `M${so(x)} ${so(y)}`;
      do_dai_doan = 1;
    }
    truoc = { x, y, t, seat: d.seat };
  }
  ket_thuc_doan();
  return { nen, dam, le };
}

/** Chỉ số của lần đo GẦN `t` nhất (tìm nhị phân); không có lần đo nào → null. Hai lần đo cách đều thì lấy lần sớm hơn. */
export function chiSoLanDoGanNhat(thoi_diem: number[], t: number): number | null {
  const n = thoi_diem.length;
  if (n === 0 || !Number.isFinite(t)) return null;
  let lo = 0, hi = n - 1;
  while (lo < hi) {
    const giua = (lo + hi) >> 1;
    if (thoi_diem[giua] < t) lo = giua + 1; else hi = giua;
  }
  if (lo > 0 && Math.abs(thoi_diem[lo - 1] - t) <= Math.abs(thoi_diem[lo] - t)) return lo - 1;
  return lo;
}

/** Các mốc nhãn của trục thời gian theo GIỜ MÁY: 6 giờ → mỗi giờ tròn ("14:00"), 24 giờ → mỗi 4 giờ tròn (00:00, 04:00…), 7 ngày → mỗi nửa đêm ("13/10"). Chỉ mốc nằm trong [tu, den]. */
export function cacMocThoiGian(tu: number, den: number, khoang: KhoangQuota): { t: number; nhan: string }[] {
  if (!Number.isFinite(tu) || !Number.isFinite(den) || den <= tu) return [];
  const ra: { t: number; nhan: string }[] = [];
  const d = new Date(tu);
  if (khoang === '7d') {
    d.setHours(0, 0, 0, 0);
    if (d.getTime() < tu) d.setDate(d.getDate() + 1);
    for (let k = 0; k < 400 && d.getTime() <= den; k++) {
      ra.push({ t: d.getTime(), nhan: `${h2(d.getDate())}/${h2(d.getMonth() + 1)}` });
      d.setDate(d.getDate() + 1);
    }
    return ra;
  }
  const buoc = khoang === '6h' ? 1 : 4;
  d.setMinutes(0, 0, 0);
  d.setHours(d.getHours() - (d.getHours() % buoc));
  while (d.getTime() < tu) d.setHours(d.getHours() + buoc);
  for (let k = 0; k < 400 && d.getTime() <= den; k++) {
    ra.push({ t: d.getTime(), nhan: `${h2(d.getHours())}:${h2(d.getMinutes())}` });
    d.setHours(d.getHours() + buoc);
  }
  return ra;
}

const tenChiSoQuota = (chi_so: ChiSoQuota) => (chi_so === '7d' ? 'quota 7 ngày' : 'quota 5 giờ');
/** Một câu mô tả cả biểu đồ cho bàn đọc màn hình: số hồ sơ, số lần đo, giá trị mới nhất của từng hồ sơ. Chưa có số liệu thì nói thẳng. */
export function tomTatQuota(c: ChuoiQuota, khoang: KhoangQuota): string {
  const mo_dau = `Biểu đồ đường ${tenChiSoQuota(c.chi_so)} của từng hồ sơ, ${NHAN_KHOANG_QUOTA[khoang]} gần nhất`;
  if (c.series.length === 0 || c.thoi_diem.length === 0) return `${mo_dau}: chưa có số liệu.`;
  const moi_nhat = c.series.filter((s) => s.gia_tri_cuoi !== null).map((s) => `${s.ten} ${Math.round(s.gia_tri_cuoi as number)}%`).join(', ');
  return `${mo_dau}: ${c.series.length} hồ sơ, ${c.thoi_diem.length} lần đo; giá trị mới nhất: ${moi_nhat}.`;
}
/** Mô tả MỘT lần đo (tooltip / vùng đọc cho bàn phím): "14:20 13/10: thanh@ith 42% (giữ seat), vgg@ith 18%"; chỉ số ngoài khoảng → "". */
export function moTaLanDoQuota(c: ChuoiQuota, k: number): string {
  if (!Number.isInteger(k) || k < 0 || k >= c.thoi_diem.length) return '';
  const gio = gioVaNgay(new Date(c.thoi_diem[k]).toISOString());
  const phan = c.series
    .map((s) => ({ ten: s.ten, d: s.diem[k] }))
    .filter((x) => x.d && x.d.v !== null)
    .map((x) => `${x.ten} ${Math.round(x.d.v as number)}%${x.d.seat ? ' (giữ seat)' : ''}`);
  return phan.length ? `${gio}: ${phan.join(', ')}` : `${gio}: không hồ sơ nào có số liệu`;
}

/** Câu dự báo hiển thị cho hồ sơ giữ seat (kết quả của phanTichDuBaoQuota). Chỉ nói điều dữ liệu cho thấy: không đủ mẫu thì nói "chưa đủ mẫu", không đoán. */
export function cauDuBaoQuota(d: DuBaoQuota, nguong: number): string {
  if (d.loai === 'chua-du-mau') return `Chưa đủ mẫu để dự báo: cần ít nhất 3 lần đo trải trên 10 phút trong 60 phút gần nhất, hiện có ${d.so_mau}.`;
  if (d.loai === 'da-vuot') return `Quota 5 giờ đã ở ${Math.round(d.hien_tai)}% — đã chạm ngưỡng đổi seat ${nguong}%.`;
  if (d.loai === 'on-dinh') return `Quota 5 giờ ổn định ở ${Math.round(d.hien_tai)}% — chưa thấy dấu hiệu chạm ngưỡng đổi seat ${nguong}% trong vài giờ tới.`;
  const con = !Number.isFinite(d.phut) ? 'chưa rõ còn bao lâu' : d.phut < 1 ? 'ngay bây giờ' : `còn ~${thoiGianImLang(d.phut)}`;
  return `Theo đà hiện tại, quota 5 giờ chạm ngưỡng đổi seat ${nguong}% khoảng ${Number.isFinite(d.luc) ? gioTrongNgay(new Date(d.luc).toISOString()) : '—'} — ${con} (đang tăng ~${thapPhan(Math.round(d.doc * 10) / 10)} điểm % mỗi giờ, hiện ${Math.round(d.hien_tai)}%).`;
}

// ═══════════ Lịch chạy định kỳ (routines): nhãn kết quả, giờ kế tiếp, dòng bảng, tóm tắt ═══════════
// Hàm thuần cho mảng "Lịch chạy" (views/vclaw/LichChay.tsx). Không đọc đồng hồ: `bay_gio` do nơi gọi truyền. Giờ ghép bằng `gioVaNgay` — giờ máy, như mọi mảng khác của trang
// (máy của chủ ở múi giờ Việt Nam). Mã và tên lịch là dữ liệu từ repo của chủ: chỉ hiện dạng chữ, giao diện không bao giờ chèn HTML.
/** Mức của kết quả lần chạy cuối: tốt = chạy xong; cần chú ý = lịch không chạy được hoặc lỗi (chủ có thể phải làm gì đó); thông tin = bình thường / do chủ chọn. */
export type MucKetQuaLich = 'tot' | 'chu-y' | 'thong-tin';
export const NHAN_MUC_LICH: Record<MucKetQuaLich, string> = { tot: 'Tốt', 'chu-y': 'Cần chú ý', 'thong-tin': 'Thông tin' };
export type NhanKetQuaLich = { ten: string; muc: MucKetQuaLich; mo_ta: string };
export const NHAN_KET_QUA_LICH: Record<KetQuaLich, NhanKetQuaLich> = {
  ok: { ten: 'Chạy xong', muc: 'tot', mo_ta: 'Lần gần nhất chạy xong.' },
  fail: { ten: 'Chạy lỗi', muc: 'chu-y', mo_ta: 'Lần gần nhất gặp lỗi — xem việc tương ứng ở mảng Lịch sử việc (huy hiệu “Lịch: <mã>”).' },
  cancelled: { ten: 'Bị dừng', muc: 'thong-tin', mo_ta: 'Lần gần nhất bị dừng giữa chừng bằng lệnh /dung.' },
  'skip-quota': { ten: 'Bỏ qua: quota cao', muc: 'chu-y', mo_ta: 'Lần gần nhất bị bỏ vì quota 5 giờ đang cao — xem mảng Quota theo thời gian.' },
  'skip-late': { ten: 'Bỏ qua: lỡ giờ', muc: 'chu-y', mo_ta: 'Lần gần nhất lỡ giờ quá cửa sổ bù (máy hoặc VClaw đang tắt) nên bị bỏ.' },
  'skip-locked': { ten: 'Bỏ qua: đang khoá PIN', muc: 'chu-y', mo_ta: 'Lần gần nhất bị bỏ vì VClaw đang khoá bằng PIN — mở khoá trên Telegram thì lịch mới chạy được.' },
  'skip-busy': { ten: 'Bỏ qua: lần trước chưa xong', muc: 'thong-tin', mo_ta: 'Lần gần nhất bị bỏ vì lần chạy trước vẫn đang làm.' },
};
export const NHAN_CHUA_CO_KET_QUA: NhanKetQuaLich = { ten: 'Chưa có kết quả', muc: 'thong-tin', mo_ta: 'VClaw chưa ghi kết quả lần chạy nào của lịch này.' };
/** Kết quả lần chạy cuối → nhãn chữ + mức. Không có hoặc lạ (kể cả tên nguy hiểm như __proto__, constructor) → "Chưa có kết quả". */
export function nhanKetQuaLich(kq: unknown): NhanKetQuaLich {
  return typeof kq === 'string' && Object.hasOwn(NHAN_KET_QUA_LICH, kq) ? NHAN_KET_QUA_LICH[kq as KetQuaLich] : NHAN_CHUA_CO_KET_QUA;
}

/** Giờ chạy kế tiếp để HIỆN: còn ở tương lai thì giữ nguyên; ở quá khứ (con số cũ — VClaw hoặc máy đã tắt, chưa kịp ghi lại), sai hoặc thiếu → null. */
export function keTiepLichChay(next: string | null | undefined, bay_gio: number): string | null {
  if (typeof next !== 'string' || !Number.isFinite(bay_gio)) return null;
  const t = Date.parse(next);
  return Number.isFinite(t) && t > bay_gio ? next : null;
}

/** "07:30 13/10 · sau 12 phút" (tương lai) hoặc "07:30 13/10 · 3 giờ trước" (quá khứ). Sai hoặc thiếu thời điểm → "". */
export function nhanGioLich(iso: string | null | undefined, bay_gio: number): string {
  const t = typeof iso === 'string' ? Date.parse(iso) : NaN;
  if (Number.isNaN(t) || !Number.isFinite(bay_gio)) return '';
  const gio = gioVaNgay(iso);
  if (t > bay_gio) {
    const phut = Math.floor((t - bay_gio) / 60_000);
    return `${gio} · ${phut < 1 ? 'sắp tới' : `sau ${thoiGianImLang(phut)}`}`;
  }
  return `${gio} · ${tuoiTuongDoi(iso, bay_gio)}`;
}

export type DongLichChay = {
  id: string; ten: string; cron: string;
  /** null = VClaw không ghi */
  bat: boolean | null;
  /** giờ kế tiếp còn ở tương lai (ISO) hoặc null; lịch đang tắt luôn null */
  ke_tiep: string | null;
  nhan_ke_tiep: string;
  ma_ket_qua: KetQuaLich | null;
  ket_qua: NhanKetQuaLich;
  /** giờ ghi kết quả cuối (thiếu thì lần chạy thật cuối), dạng "07:30 13/10 · 3 giờ trước"; không có giờ nào → "" */
  nhan_gio_ket_qua: string;
  /** chỉ khi kết quả cuối là một lần BỎ QUA: lần chạy THẬT gần nhất (nếu có) — để không lẫn "bỏ qua hôm nay" với "chạy gần nhất"; còn lại "" */
  nhan_chay_that: string;
  /** ô Agent: chữ chính + chữ phụ (giải thích; rỗng khi không cần) + kiểu — xem nhanAgentLich / chuAgentLich (đội agent) */
  agent: { chinh: string; phu: string; kieu: KieuAgentLich };
  /** "Ưu tiên 2" hoặc "—" (VClaw không ghi) */
  uu_tien: string;
};
/** Một lịch (đã làm sạch) → mọi chữ cần hiện ở một dòng bảng / một thẻ. `agents` = danh bạ đội agent của trạng thái (đổi mã agent sang tên; chưa có → hiện mã). */
export function dongLichChay(m: MucLichChay, bay_gio: number, agents: AgentsVclaw | null | undefined = null): DongLichChay {
  const ke_tiep = m.enabled === false ? null : keTiepLichChay(m.next, bay_gio);
  const bo_qua = typeof m.last_result === 'string' && m.last_result.startsWith('skip-');
  const ag = nhanAgentLich(m, agents);
  return {
    id: m.id, ten: m.name || m.id, cron: m.cron, bat: m.enabled,
    ke_tiep, nhan_ke_tiep: ke_tiep ? nhanGioLich(ke_tiep, bay_gio) : '',
    ma_ket_qua: m.last_result, ket_qua: nhanKetQuaLich(m.last_result),
    nhan_gio_ket_qua: nhanGioLich(m.last_result_at ?? m.last_run, bay_gio),
    nhan_chay_that: bo_qua && m.last_run ? nhanGioLich(m.last_run, bay_gio) : '',
    agent: { ...chuAgentLich(ag), kieu: ag.kieu }, uu_tien: nhanUuTienLich(m.priority),
  };
}

export type TomTatLichChay = {
  so_lich: number; so_bat: number;
  /** số lịch có kết quả cuối ở mức "cần chú ý" */
  so_chu_y: number;
  /** lịch đang bật có giờ kế tiếp sớm nhất (còn ở tương lai); không có → null */
  ke_tiep: { id: string; ten: string; luc: string } | null;
};
export function tomTatLichChay(l: LichChayVclaw | null | undefined, bay_gio: number): TomTatLichChay {
  const t: TomTatLichChay = { so_lich: 0, so_bat: 0, so_chu_y: 0, ke_tiep: null };
  for (const m of mangAnToan(l?.items)) {
    t.so_lich++;
    if (m.enabled === true) t.so_bat++;
    if (nhanKetQuaLich(m.last_result).muc === 'chu-y') t.so_chu_y++;
    const luc = m.enabled === false ? null : keTiepLichChay(m.next, bay_gio);
    if (luc && (!t.ke_tiep || Date.parse(luc) < Date.parse(t.ke_tiep.luc))) t.ke_tiep = { id: m.id, ten: m.name || m.id, luc };
  }
  return t;
}

/** Dòng chip "Tệp qua Telegram: nhận bật · gửi tắt" — giá trị VClaw không ghi (null) hiện "chưa rõ" (không đoán bật hay tắt). */
export function chuTepTelegram(f: LichChayVclaw['files'] | null | undefined): string {
  const chu = (v: boolean | null | undefined) => (v === true ? 'bật' : v === false ? 'tắt' : 'chưa rõ');
  return `Tệp qua Telegram: nhận ${chu(f?.receive)} · gửi ${chu(f?.send)}`;
}

// ── Tìm chat nhiều ngày (GET /api/vclaw/tim): kiểu trả về, đoạn làm nổi từ khoá, nhóm theo ngày, ghi chú, xuất .md / .csv — hàm THUẦN (giao diện ở views/vclaw/TimChat.tsx) ──
export type { HuongTin, KetQuaTimChat, SoNgayTim };
/** GET /api/vclaw/tim — `co` = đọc được ít nhất một tệp ngày; `da_quet` / `thieu` / `loi_doc` = số ngày quét được / không có tệp / KHÔNG đọc được vì lỗi (kết quả có thể thiếu những ngày này);
 *  `tong` = số tin khớp (đủ), `ds` = tối đa 100 tin MỚI NHẤT; `tu`..`den` = cửa sổ ngày (giờ VN). */
export type TraTimChat = {
  co: boolean; repo: string; q: string; loai: HuongTin[]; so_ngay: number; tu: string; den: string;
  da_quet: number; thieu: number; loi_doc: number; tong: number; cat_bot: boolean; ds: KetQuaTimChat[];
};
export type ThamSoTimChat = { q: string; ngay: SoNgayTim; loai: HuongTin[] };

/** Đường gọi API (api.get tự thêm /api/ ở đầu). Mọi giá trị qua encodeURIComponent; `loai` chỉ có khi KHÔNG chọn đủ ba hướng. */
export const duongTimChat = (p: ThamSoTimChat): string =>
  `vclaw/tim?q=${encodeURIComponent(p.q)}&ngay=${p.ngay}${p.loai.length < HUONG_TIN.length ? `&loai=${p.loai.join(',')}` : ''}`;

export type DoanLamNoi = { chu: string; khop: boolean };
/** Tách đoạn trích thành các phần chữ thường và phần khớp từ khoá (để giao diện dựng <mark> — KHÔNG chèn HTML). Nối mọi `chu` lại luôn ra đúng `doan`; không có phần rỗng.
 *  Dùng đúng hàm tìm vị trí của máy chủ nên không có chuyện máy chủ báo khớp mà trang không làm nổi được. */
export function tachDoanLamNoi(doan: string, q: string): DoanLamNoi[] {
  if (typeof doan !== 'string' || doan === '') return [];
  const ra: DoanLamNoi[] = [];
  let tu = 0;
  for (const [s, e] of viTriKhop(doan, q, 20)) {
    if (s > tu) ra.push({ chu: doan.slice(tu, s), khop: false });
    ra.push({ chu: doan.slice(s, e), khop: true });
    tu = e;
  }
  if (tu < doan.length) ra.push({ chu: doan.slice(tu), khop: false });
  return ra;
}

const GIO_VN_MS = 7 * 3600_000;
/** ISO → "HH:mm" theo GIỜ VIỆT NAM (UTC+7), cùng múi giờ với tên tệp ngày của VClaw — nhóm "ngày 13/10" không lẫn giờ của ngày khác khi xem từ máy đặt múi giờ khác. Sai / ngoài miền → "—". */
export function gioVn(iso: string | null | undefined): string {
  const t = typeof iso === 'string' ? Date.parse(iso) : NaN;
  return Number.isNaN(t) || t < Date.UTC(1000, 0, 1) || t >= Date.UTC(9999, 0, 1) ? '—' : new Date(t + GIO_VN_MS).toISOString().slice(11, 16);
}
const ngayGioVn = (bay_gio: number): string => {
  if (!Number.isFinite(bay_gio) || Math.abs(bay_gio) > 8.64e15 - GIO_VN_MS) return '—';
  const d = new Date(bay_gio + GIO_VN_MS).toISOString();
  return `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)} ${d.slice(11, 16)}`;
};

export type NhomNgayTim = { ngay: string; ds: KetQuaTimChat[] };
/** Nhóm kết quả theo ngày, giữ thứ tự xuất hiện (mới nhất trước) — mỗi ngày đúng MỘT nhóm. */
export function nhomTheoNgay(ds: KetQuaTimChat[]): NhomNgayTim[] {
  const m = new Map<string, KetQuaTimChat[]>();
  for (const r of ds) {
    const l = m.get(r.ngay);
    if (l) l.push(r);
    else m.set(r.ngay, [r]);
  }
  return [...m].map(([ngay, nhom]) => ({ ngay, ds: nhom }));
}

/** "Đã quét 7 ngày · 1 ngày không có tệp · 2 ngày CHƯA ĐỌC ĐƯỢC" — số ngày chưa đọc được luôn được nói ra. */
export function cauDaQuetTim(kq: Pick<TraTimChat, 'da_quet' | 'thieu' | 'loi_doc'>): string {
  return [`Đã quét ${kq.da_quet} ngày`, ...(kq.thieu > 0 ? [`${kq.thieu} ngày không có tệp`] : []), ...(kq.loi_doc > 0 ? [`${kq.loi_doc} ngày CHƯA ĐỌC ĐƯỢC`] : [])].join(' · ');
}

export type GhiChuTim = { muc: 'chu-y' | 'thong-tin'; chu: string };
/** Ghi chú dưới dòng tóm tắt: ngày chưa đọc được (cần chú ý — kết quả có thể thiếu), không có tệp nào, ngày thiếu tệp (thông tin), kết quả bị cắt còn 100 (thông tin). */
export function ghiChuKetQuaTim(kq: TraTimChat): GhiChuTim[] {
  const ra: GhiChuTim[] = [];
  if (kq.loi_doc > 0) ra.push({ muc: 'chu-y', chu: `Chưa đọc được ${kq.loi_doc} ngày (GitHub lỗi tạm thời hoặc tệp của ngày đó quá lớn) — kết quả có thể thiếu những ngày này. Bấm Tìm lại để thử lần nữa.` });
  if (kq.da_quet === 0 && kq.loi_doc === 0) ra.push({ muc: 'chu-y', chu: `Không có tệp chat nào trong ${kq.so_ngay} ngày gần nhất (${ngayDayDu(kq.tu)} – ${ngayDayDu(kq.den)}): VClaw chưa ghi, hoặc chưa đẩy lên repo ${kq.repo}.` });
  else if (kq.thieu > 0) ra.push({ muc: 'thong-tin', chu: `${kq.thieu} ngày không có tệp chat (VClaw không ghi gì những ngày đó).` });
  if (kq.cat_bot) ra.push({ muc: 'thong-tin', chu: `Có ${kq.tong} tin khớp; đang hiện ${kq.ds.length} tin mới nhất. Dùng từ khoá cụ thể hơn hoặc chọn ít ngày hơn để thấy phần còn lại.` });
  return ra;
}

/** Trạng thái RỖNG (không tin nào khớp). Còn ngày chưa đọc được thì KHÔNG được nói "không có" — chưa thể kết luận. */
export function cauKhongCoKetQuaTim(kq: Pick<TraTimChat, 'q' | 'da_quet' | 'loi_doc'>): { tieu_de: string; mo_ta: string } {
  if (kq.loi_doc > 0) return { tieu_de: 'Chưa thể kết luận là không có', mo_ta: `Chưa thấy tin nào chứa “${kq.q}” trong ${kq.da_quet} ngày đọc được, nhưng còn ${kq.loi_doc} ngày chưa đọc được (xem ghi chú ở trên). Bấm Tìm lại để thử lần nữa.` };
  if (kq.da_quet === 0) return { tieu_de: 'Chưa có tệp chat nào để tìm', mo_ta: 'VClaw chưa ghi chat trong khoảng ngày này, hoặc chưa đẩy lên repo. Chọn khoảng ngày dài hơn hoặc quay lại sau.' };
  return { tieu_de: `Không thấy tin nào chứa “${kq.q}”`, mo_ta: `Đã quét ${kq.da_quet} ngày gần nhất. Thử từ khoá ngắn hơn (tìm không phân biệt hoa thường và dấu), chọn 14 hoặc 30 ngày, hoặc bật thêm loại tin.` };
}

/** Ô CSV chống CÔNG THỨC: Excel / Sheets coi ô bắt đầu bằng = + - @ (hoặc tab, xuống dòng) là công thức và có thể chạy nó khi mở tệp → thêm dấu ' ở đầu để thành chữ thường. */
export const chongCongThuc = (o: string): string => (/^[=+\-@\t\r]/.test(o) ? `'${o}` : o);

const loaiTinChu = (loai: readonly HuongTin[]): string => loai.map((h) => NHAN_HUONG[h]).join(', ');

/** Tệp .csv của kết quả đang hiện: UTF-8 có BOM (Excel đọc đúng tiếng Việt), CRLF, MỌI ô bọc nháy kép và qua chongCongThuc (kể cả dòng thông tin đầu tệp — từ khoá có thể bắt đầu bằng "="). */
export function taoCsvTimChat(kq: TraTimChat): string {
  const o = (v: unknown) => `"${chongCongThuc(String(v ?? '')).replace(/"/g, '""')}"`;
  const hang: string[][] = [
    ['Từ khoá', kq.q],
    ['Khoảng', `${kq.so_ngay} ngày gần nhất (${kq.tu} → ${kq.den}, tính theo ngày giờ Việt Nam)`],
    ['Loại tin', loaiTinChu(kq.loai)],
    ['Phạm vi đã quét', cauDaQuetTim(kq)],
    ['Kết quả', `${kq.tong} tin khớp, hiện ${kq.ds.length} tin mới nhất`],
    ...ghiChuKetQuaTim(kq).filter((g) => g.muc === 'chu-y').map((g) => ['Lưu ý', g.chu]),
    [],
    ['Ngày (giờ VN)', 'Giờ (UTC+7)', 'Thời điểm (UTC)', 'Loại', 'Đoạn trích'],
    ...kq.ds.map((r) => [r.ngay, gioVn(r.ts), r.ts, NHAN_HUONG[r.dir], r.doan]),
  ];
  return String.fromCharCode(0xfeff) + hang.map((h) => h.map(o).join(',')).join('\r\n') + '\r\n';
}

/** Thoát ký tự Markdown bằng dấu gạch chéo ngược: văn bản chat bất kỳ không được thành liên kết, ảnh, thẻ HTML, in đậm, bảng… khi mở tệp .md. */
const escMd = (s: string): string => s.replace(/[\\`*_[\]<>|~&]/g, '\\$&');
const doanMd = (doan: string, q: string): string => tachDoanLamNoi(doan, q).map((d) => (d.khop ? `**${escMd(d.chu)}**` : escMd(d.chu))).join('');

/** Tệp .md của kết quả đang hiện: tiêu đề + thông tin tìm (từ khoá, khoảng, loại tin, đã quét, ghi chú CẦN CHÚ Ý như ngày chưa đọc được), rồi từng ngày một mục, mỗi tin một dòng với từ khoá in đậm. */
export function taoMarkdownTimChat(kq: TraTimChat, bay_gio: number): string {
  const dong: string[] = [
    `# Tìm chat VClaw: “${escMd(kq.q)}”`,
    '',
    `- Tìm lúc: ${ngayGioVn(bay_gio)} (giờ Việt Nam)`,
    `- Từ khoá: ${escMd(kq.q)} (không phân biệt hoa thường và dấu)`,
    `- Khoảng: ${kq.so_ngay} ngày gần nhất (${ngayDayDu(kq.tu)} – ${ngayDayDu(kq.den)})`,
    `- Loại tin: ${loaiTinChu(kq.loai)}`,
    `- Phạm vi: ${cauDaQuetTim(kq)}`,
    `- Kết quả: ${kq.tong} tin khớp, hiện ${kq.ds.length} tin mới nhất`,
    ...ghiChuKetQuaTim(kq).filter((g) => g.muc === 'chu-y').map((g) => `- Lưu ý: ${escMd(g.chu)}`),
  ];
  for (const n of nhomTheoNgay(kq.ds)) {
    dong.push('', `## ${ngayDayDu(n.ngay) || escMd(n.ngay)}`, '');
    for (const r of n.ds) dong.push(`- ${gioVn(r.ts)} · ${NHAN_HUONG[r.dir]} — ${doanMd(r.doan, kq.q)}`);
  }
  dong.push('', '_Giờ theo múi giờ Việt Nam (UTC+7). Mỗi dòng là đoạn trích quanh chỗ khớp, không phải cả tin nhắn._');
  return dong.join('\n') + '\n';
}

/** Tên tệp tải về: vclaw-tim-chat-<từ khoá không dấu>-<số ngày>-ngay-<ngày cuối>.<md|csv>. Từ khoá chỉ còn chữ không dấu / số, nối bằng gạch ngang, ≤ 30 ký tự; không còn gì → "tu-khoa". */
export function tenTepXuatTim(q: string, so_ngay: number, den: string, duoi: 'md' | 'csv'): string {
  const slug = gapChuTim(typeof q === 'string' ? q : '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 30).replace(/-+$/, '') || 'tu-khoa';
  const ngay = typeof den === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(den) ? `-${den}` : '';
  return `vclaw-tim-chat-${slug}-${Number.isFinite(so_ngay) ? Math.max(0, Math.floor(so_ngay)) : 0}-ngay${ngay}.${duoi === 'md' ? 'md' : 'csv'}`;
}

// ═══════════ Đội agent: nhãn agent, tóm tắt đội, dòng thẻ agent, agent của lịch, mô tả sự kiện agent ═══════════
// Hàm thuần cho mảng "Đội agent" (views/vclaw/DoiAgent.tsx), cột Agent của "Lịch chạy", huy hiệu agent của "Lịch sử việc" và nhãn sự kiện agent của "Hive mind".
// Không đọc đồng hồ (`bay_gio` do nơi gọi truyền). Tra mã → tên LUÔN bằng `find` trên mảng, không bao giờ `đối_tượng[mã]`: `constructor` là một mã agent hợp lệ và sẽ chạm vào Object.prototype.
export const NHAN_TRANG_THAI_AGENT: Record<TrangThaiAgent, string> = { idle: 'Rảnh', running: 'Đang làm', unknown: 'Chưa rõ' };

/** Một mã agent → tên + biểu tượng từ danh bạ. Mã không có trong danh bạ (hoặc VClaw chưa ghi danh bạ) → hiện chính mã với `trong_danh_ba: false`. Mã sai dạng / không phải chuỗi → null. */
export type NhanAgent = { ma: string; ten: string; emoji: string; trong_danh_ba: boolean };
export function nhanAgent(agents: AgentsVclaw | null | undefined, ma: unknown): NhanAgent | null {
  if (typeof ma !== 'string' || !MAU_MA_AGENT.test(ma)) return null;
  const m = mangAnToan(agents?.items).find((x) => x.id === ma);
  return m ? { ma, ten: m.name || ma, emoji: m.emoji, trong_danh_ba: true } : { ma, ten: ma, emoji: '', trong_danh_ba: false };
}
/** "🔎 Nghiên cứu" (có biểu tượng), "Nghiên cứu" (không có) hoặc chính mã (không có trong danh bạ); không có agent → "—". */
export const chuAgent = (n: NhanAgent | null | undefined): string => (n ? `${n.emoji ? `${n.emoji} ` : ''}${n.ten}` : '—');

export type TomTatDoiAgent = {
  so_agent: number; dang_lam: number; ranh: number; chua_ro: number;
  /** tổng việc đang chờ ở các làn (agent không ghi số thì bỏ qua) */
  hang_cho: number;
  /** tổng việc hôm nay (agent không ghi số thì bỏ qua) */
  viec_hom_nay: number;
  /** số agent mà việc gần nhất bị lỗi */
  so_loi_cuoi: number;
};
/** Đếm cho dòng tóm tắt đầu mảng ("8 agent · 3 đang làm · 5 rảnh · 1 việc chờ · 17 việc hôm nay"). Không có đội → toàn 0. */
export function tomTatDoiAgent(agents: AgentsVclaw | null | undefined): TomTatDoiAgent {
  const t: TomTatDoiAgent = { so_agent: 0, dang_lam: 0, ranh: 0, chua_ro: 0, hang_cho: 0, viec_hom_nay: 0, so_loi_cuoi: 0 };
  for (const m of mangAnToan(agents?.items)) {
    t.so_agent++;
    if (m.state === 'running') t.dang_lam++;
    else if (m.state === 'idle') t.ranh++;
    else t.chua_ro++;
    t.hang_cho += m.queued ?? 0;
    t.viec_hom_nay += m.jobs_today ?? 0;
    if (m.last_ok === false) t.so_loi_cuoi++;
  }
  return t;
}

export type KetQuaCuoiAgent = 'xong' | 'loi' | null;
export type DongAgent = {
  id: string; ten: string; emoji: string; vai: string;
  trang_thai: TrangThaiAgent; nhan_trang_thai: string;
  /** công cụ đang dùng — chỉ khi đang làm; còn lại '' */
  cong_cu: string;
  hang_cho: number | null; nhan_hang_cho: string;
  viec_hom_nay: number | null; nhan_viec_hom_nay: string;
  ket_qua_cuoi: KetQuaCuoiAgent; nhan_ket_qua_cuoi: string;
  /** "12 phút trước"; '' khi VClaw không ghi mốc giờ */
  nhan_gio_cuoi: string;
  mac_dinh: boolean; dang_ghim: boolean;
};
/** Một agent (đã làm sạch) → mọi chữ cần hiện ở một thẻ. Trạng thái ngoài bảng (không xảy ra với dữ liệu đã làm sạch) → "Chưa rõ". */
export function dongAgent(m: MucAgent, agents: AgentsVclaw | null | undefined, bay_gio: number): DongAgent {
  const ket_qua: KetQuaCuoiAgent = m.last_ok === true ? 'xong' : m.last_ok === false ? 'loi' : null;
  const co_gio = typeof m.last_at === 'string';
  const hang_cho = m.queued ?? null, viec = m.jobs_today ?? null;
  return {
    id: m.id, ten: m.name || m.id, emoji: m.emoji, vai: m.role,
    trang_thai: m.state, nhan_trang_thai: Object.hasOwn(NHAN_TRANG_THAI_AGENT, m.state) ? NHAN_TRANG_THAI_AGENT[m.state] : NHAN_TRANG_THAI_AGENT.unknown,
    cong_cu: m.state === 'running' ? m.tool : '',
    hang_cho, nhan_hang_cho: hang_cho === null ? 'chưa rõ' : hang_cho === 0 ? 'không có việc chờ' : `${hang_cho} việc chờ`,
    viec_hom_nay: viec, nhan_viec_hom_nay: viec === null ? '—' : `${viec} việc`,
    ket_qua_cuoi: ket_qua,
    nhan_ket_qua_cuoi: ket_qua === 'xong' ? 'Xong' : ket_qua === 'loi' ? 'Lỗi' : co_gio ? 'Chưa rõ kết quả' : 'Chưa chạy việc nào',
    nhan_gio_cuoi: co_gio ? tuoiTuongDoi(m.last_at, bay_gio) : '',
    mac_dinh: agents?.default === m.id, dang_ghim: agents?.pinned === m.id,
  };
}

/** Khi VClaw đã im quá ngưỡng (45 phút) thì "Đang làm" và hàng chờ của từng agent là ảnh chụp CŨ → câu cảnh báo; VClaw còn báo đều (hoặc chưa có mốc giờ) → null. */
export function cauSoLieuAgentCu(updated: string | null | undefined, bay_gio: number): string | null {
  const phut = vclawKhongPhanHoi(updated, bay_gio);
  return phut === null ? null : `Số liệu cũ: VClaw báo lần cuối lúc ${gioVaNgay(updated)} (${thoiGianImLang(phut)} trước) — trạng thái “Đang làm” và hàng chờ có thể đã đổi.`;
}

// ── Agent của một lịch ──
/** agent: lịch khai agent (có trong danh bạ, hoặc danh bạ chưa ghi); khong-co: lịch khai agent mà danh bạ đang bật không có mã đó (VClaw chạy bằng agent mặc định);
 *  mac-dinh: lịch không khai agent, đội bật → agent mặc định; doi-tat: đội đang tắt, khai báo agent chưa có tác dụng; chua-ro: không có thông tin (VClaw bản cũ). */
export type KieuAgentLich = 'agent' | 'khong-co' | 'mac-dinh' | 'doi-tat' | 'chua-ro';
export type NhanAgentLich = { kieu: KieuAgentLich; agent: NhanAgent | null };
export function nhanAgentLich(m: Pick<MucLichChay, 'agent'>, agents: AgentsVclaw | null | undefined): NhanAgentLich {
  const khai = nhanAgent(agents, m?.agent);
  if (agents && agents.enabled === false) return { kieu: 'doi-tat', agent: khai };
  if (khai) return { kieu: agents && !khai.trong_danh_ba ? 'khong-co' : 'agent', agent: khai };
  if (agents && agents.enabled === true) return { kieu: 'mac-dinh', agent: nhanAgent(agents, agents.default) };
  return { kieu: 'chua-ro', agent: null };
}
/** Chữ chính + chữ phụ (giải thích) của ô Agent. Chữ phụ rỗng khi không cần. */
export function chuAgentLich(n: NhanAgentLich): { chinh: string; phu: string } {
  if (n.kieu === 'agent') return { chinh: chuAgent(n.agent), phu: '' };
  if (n.kieu === 'khong-co') return { chinh: chuAgent(n.agent), phu: 'không có trong danh bạ — VClaw chạy bằng agent mặc định' };
  if (n.kieu === 'mac-dinh') return { chinh: n.agent ? chuAgent(n.agent) : 'Agent mặc định', phu: 'agent mặc định (lịch không khai agent)' };
  if (n.kieu === 'doi-tat') return { chinh: '—', phu: 'đội agent đang tắt' };
  return { chinh: '—', phu: '' };
}
export const GHI_CHU_UU_TIEN_LICH = 'Ưu tiên từ 1 đến 5: khi nhiều lịch cùng đến hạn, số nhỏ chạy trước (mặc định 3).';
/** "Ưu tiên 2" hoặc "—" (VClaw không ghi / ngoài 1–5). */
export const nhanUuTienLich = (p: number | null | undefined): string => (typeof p === 'number' && Number.isInteger(p) && p >= 1 && p <= 5 ? `Ưu tiên ${p}` : '—');

// ── Sự kiện agent ở Hive mind ──
const KIND_SU_KIEN_AGENT: readonly string[] = ['agent_job', 'agent_delegate', 'agent_error'];
export type MoTaSuKienAgent = {
  /** tiêu đề dòng; luôn có chữ */
  ten: string;
  /** kết quả (agent_job): true xong, false lỗi; null = không rõ / loại khác. agent_error luôn false. */
  ok: boolean | null;
  /** tiêu đề đã dựng từ meta (mã agent → tên trong danh bạ) → câu `text` của VClaw chỉ lặp lại nội dung đó (trừ khi lỗi: câu đó có lý do) */
  tu_meta: boolean;
};
/** Tiêu đề của sự kiện agent: đọc `meta.agent` / `meta.from` / `meta.to` rồi đổi mã sang tên (+ biểu tượng) trong danh bạ; mã không có trong danh bạ thì hiện chính mã; thiếu meta → nhãn của loại. Loại khác → null. */
export function moTaSuKienAgent(s: Pick<SuKienVclaw, 'kind' | 'meta'>, agents: AgentsVclaw | null | undefined): MoTaSuKienAgent | null {
  if (!s || !KIND_SU_KIEN_AGENT.includes(s.kind)) return null;
  const meta = s.meta ?? {};
  if (s.kind === 'agent_delegate') {
    const tu = nhanAgent(agents, meta.from), den = nhanAgent(agents, meta.to);
    return tu && den ? { ten: `${chuAgent(tu)} giao việc cho ${chuAgent(den)}`, ok: null, tu_meta: true } : { ten: NHAN_SU_KIEN.agent_delegate.ten, ok: null, tu_meta: false };
  }
  if (s.kind === 'agent_job') {
    const ok = meta.ok === 1 ? true : meta.ok === 0 ? false : null;
    const ag = nhanAgent(agents, meta.agent);
    if (!ag) return { ten: NHAN_SU_KIEN.agent_job.ten, ok, tu_meta: false };
    return { ten: `${chuAgent(ag)} ${ok === true ? 'xong việc' : ok === false ? 'làm việc lỗi' : 'báo kết quả việc'}`, ok, tu_meta: true };
  }
  return { ten: NHAN_SU_KIEN.agent_error.ten, ok: false, tu_meta: false };
}
/** Đếm sự kiện agent của một ngày cho dòng tóm tắt Hive mind: việc agent xong / lỗi (đọc meta.ok), số lần giao việc, số lần danh bạ báo lỗi. */
export type TomTatSuKienAgent = { viec_xong: number; viec_loi: number; giao_viec: number; loi_danh_ba: number };
export function tomTatSuKienAgent(ds: SuKienVclaw[]): TomTatSuKienAgent {
  const t: TomTatSuKienAgent = { viec_xong: 0, viec_loi: 0, giao_viec: 0, loi_danh_ba: 0 };
  for (const s of mangAnToan(ds)) {
    if (s.kind === 'agent_job') {
      if (s.meta?.ok === 1) t.viec_xong++;
      else if (s.meta?.ok === 0) t.viec_loi++;
    } else if (s.kind === 'agent_delegate') t.giao_viec++;
    else if (s.kind === 'agent_error') t.loi_danh_ba++;
  }
  return t;
}

// ── Sổ cái việc + việc đang chạy: agent ──
export type ViecTheoAgent = { agent: string; so_viec: number; so_xong: number; so_loi: number };
/** Gộp việc của sổ cái theo agent (chỉ việc có `agent`); nhiều việc nhất trước, hoà → theo mã. Việc không có agent (đội tắt / VClaw bản cũ) bị bỏ. */
export function demViecTheoAgent(ds: ViecSoCai[]): ViecTheoAgent[] {
  const m = new Map<string, { so_viec: number; so_xong: number }>();
  for (const v of mangAnToan(ds)) {
    if (typeof v.agent !== 'string' || !MAU_MA_AGENT.test(v.agent)) continue;
    const c = m.get(v.agent) ?? { so_viec: 0, so_xong: 0 };
    c.so_viec++;
    if (v.ok) c.so_xong++;
    m.set(v.agent, c);
  }
  return [...m].map(([agent, c]) => ({ agent, so_viec: c.so_viec, so_xong: c.so_xong, so_loi: c.so_viec - c.so_xong })).sort((a, b) => b.so_viec - a.so_viec || soSanhChu(a.agent, b.agent));
}
/** Một việc đang chạy → "🔎 Nghiên cứu: 3 phút (Bash) +1 chờ" (không có agent thì bỏ phần đầu — đội tắt / VClaw bản cũ). */
export function moTaViecDangChay(j: ViecVclaw, agents: AgentsVclaw | null | undefined, bay_gio: number = Date.now()): string {
  const ag = nhanAgent(agents, j.agent);
  return `${ag ? `${chuAgent(ag)}: ` : ''}${thoiGianChay(j.started, bay_gio)}${j.tool ? ` (${j.tool})` : ''}${j.queued ? ` +${j.queued} chờ` : ''}`;
}

// ═══════════ Phòng tác chiến: trạng thái, gom biên bản thành cuộc họp, nhãn người nói / kiểu tin ═══════════
// Hàm thuần cho mảng "Phòng tác chiến" (views/vclaw/PhongTacChien.tsx; hook ở lib/du-lieu.ts). Không đọc đồng hồ (`bay_gio` do nơi gọi truyền). Mã agent → tên LUÔN qua nhanAgent
// (find trên mảng, không tra khoá đối tượng). Mọi hàm nhận được dữ liệu thiếu / lạ mà không ném lỗi.
export type { DongHop, KieuTinHopHoacKhac, PhongHop, WarRoomVclaw };
/** GET /api/vclaw/hop — `co` = tệp biên bản của `ngay` có tồn tại; `cat` = ngày có nhiều hơn 500 dòng (chỉ giữ 500 dòng mới nhất, nên cuộc họp CŨ NHẤT của ngày — cuối danh sách xếp mới → cũ — có thể thiếu phần đầu). */
export type TraHopVclaw = { co: boolean; repo: string; ngay: string; ds: DongHop[]; tong: number; cat: boolean };

/** Nhãn từng kiểu dòng biên bản. Giao diện luôn đặt biểu tượng cạnh nhãn chữ (không chỉ màu). */
export const NHAN_KIEU_TIN_HOP: Record<KieuTinHopHoacKhac, string> = {
  hoi: 'Câu hỏi', 'tra-loi': 'Trả lời', 'phan-bien': 'Phản biện', 'tong-hop': 'Kết luận', 'de-xuat': 'Đề xuất giao việc', 'he-thong': 'Thông báo hệ thống', khac: 'Tin khác',
};
/** Nơi cuộc họp bắt đầu. */
export const NHAN_PHONG_HOP: Record<PhongHop, string> = { tele: 'Telegram', web: 'Trang cục bộ', khac: 'Không rõ nơi họp' };

/** Nhãn của một dòng biên bản. Hai kiểu đổi theo ngữ cảnh: `hoi` TRONG cuộc họp là "Chủ đề họp"; `tra-loi` NẰM SAU kết luận của cuộc họp là kết quả một việc chủ đã bấm giao ("Trả lời việc được giao").
 *  Kiểu ngoài bảng (không xảy ra với dữ liệu đã làm sạch) → "Tin khác". */
export function nhanKieuTinHop(d: { kind: string; sau_ket_luan?: boolean; trong_hop?: boolean }): string {
  if (d.kind === 'hoi' && d.trong_hop) return 'Chủ đề họp';
  if (d.kind === 'tra-loi' && d.sau_ket_luan) return 'Trả lời việc được giao';
  return Object.hasOwn(NHAN_KIEU_TIN_HOP, d.kind) ? NHAN_KIEU_TIN_HOP[d.kind as KieuTinHopHoacKhac] : NHAN_KIEU_TIN_HOP.khac;
}

/** Người nói của một dòng: chủ ('owner' — luôn là chủ, kể cả khi danh bạ có agent mã owner), hệ thống, một agent (tên + biểu tượng từ danh bạ; mã không có trong danh bạ → hiện chính mã; riêng mã `vclaw`
 *  — VClaw trả lời khi đội agent tắt — hiện "VClaw"), hoặc không rõ (mã sai dạng / rỗng). */
export type NguoiNoiHop = { loai: 'chu' | 'he-thong' | 'agent' | 'khong-ro'; ten: string; emoji: string; trong_danh_ba: boolean };
export function nguoiNoiHop(who: unknown, agents: AgentsVclaw | null | undefined): NguoiNoiHop {
  if (who === 'owner') return { loai: 'chu', ten: 'Bạn', emoji: '', trong_danh_ba: false };
  if (who === 'he-thong') return { loai: 'he-thong', ten: 'Hệ thống', emoji: '', trong_danh_ba: false };
  const a = nhanAgent(agents, who);
  if (!a) return { loai: 'khong-ro', ten: 'Không rõ người nói', emoji: '', trong_danh_ba: false };
  if (!a.trong_danh_ba && a.ma === 'vclaw') return { loai: 'agent', ten: 'VClaw', emoji: '', trong_danh_ba: false };
  return { loai: 'agent', ten: a.ten, emoji: a.emoji, trong_danh_ba: a.trong_danh_ba };
}
/** "💰 Tài chính", "Bạn", "Hệ thống"… — chữ hiện cho một người nói. */
export const chuNguoiNoiHop = (n: NguoiNoiHop): string => (n.emoji ? `${n.emoji} ${n.ten}` : n.ten);

/** Một dòng biên bản trong cuộc họp, kèm `sau_ket_luan` = đã có dòng `tong-hop` ĐỨNG TRƯỚC nó trong cùng cuộc họp (dòng `tong-hop` đầu tiên thì không). */
export type DongBienBan = DongHop & { sau_ket_luan: boolean };
export type SoDemHop = {
  /** câu trả lời của thành viên (vòng 1), không tính kết quả việc được giao sau họp */
  tra_loi: number; phan_bien: number; de_xuat: number; he_thong: number; khac: number;
  /** câu trả lời đứng SAU kết luận = kết quả các việc chủ đã bấm giao */
  viec_giao: number;
};
export type CuocHop = {
  sid: string;
  /** `ts` của dòng đầu / dòng cuối trong tệp của ngày đang xem */
  bat_dau: string; ket_thuc: string;
  /** chữ của dòng `hoi` đầu tiên (chủ đề); '' khi tệp ngày này không có dòng đó (cuộc họp bắt đầu hôm trước — chỉ còn phần việc được giao sau họp) */
  chu_de: string;
  /** nơi bắt đầu: dòng đầu có `room` đọc được; '' = không rõ */
  room: PhongHop | '';
  /** mã agent đã nói ở vòng 1 / vòng 2 (không kể người trả lời việc được giao sau họp), theo thứ tự xuất hiện lần đầu */
  nguoi_du: string[];
  /** mã agent viết kết luận (chỉ huy); '' khi chưa có kết luận */
  chi_huy: string;
  /** chữ của kết luận (dòng `tong-hop` đầu); '' khi chưa có */
  ket_luan: string;
  co_ket_luan: boolean;
  /** có dòng hệ thống bắt đầu bằng "⏹" ("⏹ Cuộc họp đã bị huỷ." — chủ gõ /dung hoặc bấm Dừng). Hợp đồng VClaw KHÔNG có trường `stage`: huỷ chỉ nhận ra từ dòng này. */
  bi_huy: boolean;
  so: SoDemHop;
  /** ngày bắt đầu cuộc họp đọc từ mã (`hop-YYYYMMDD-…`), định dạng YYYY-MM-DD; '' khi mã không có dạng đó */
  ngay_goc: string;
  dong: DongBienBan[];
};
export type HopNgay = {
  /** mới nhất trước */
  cuoc_hop: CuocHop[];
  /** lời chat thường trong phòng (không có mã cuộc họp), cũ → mới */
  ngoai_hop: DongBienBan[];
  /** tổng số dòng đã xét */
  tong_dong: number;
};

/** "hop-20261013-094100" (hoặc "-2") → "2026-10-13"; mã khác dạng hoặc ngày không có thật → "". */
export function ngayTuMaHop(sid: unknown): string {
  const m = typeof sid === 'string' ? /^hop-(\d{4})(\d{2})(\d{2})-\d{6}(?:-\d{1,3})?$/.exec(sid) : null;
  const ngay = m ? `${m[1]}-${m[2]}-${m[3]}` : '';
  return ngay && laNgayHopLe(ngay) ? ngay : '';
}

const msDongHop = (ts: unknown): number => (typeof ts === 'string' ? Date.parse(ts) : NaN);
const laNguoiThat = (who: string): boolean => who !== '' && who !== 'owner' && who !== 'he-thong';
/** Ký hiệu mở đầu dòng hệ thống báo cuộc họp bị huỷ ("⏹ Cuộc họp đã bị huỷ.") — dấu hiệu DUY NHẤT của việc huỷ trong biên bản (hợp đồng VClaw: không có trường `stage`). */
const DAU_HUY_HOP = '⏹';

/** Gom các dòng biên bản của MỘT ngày thành cuộc họp theo `sid`: mỗi `sid` một cuộc họp (chủ đề = dòng `hoi` đầu; người dự = người nói ở vòng 1 / 2; kết luận = dòng `tong-hop` đầu;
 *  đề xuất = các dòng `de-xuat`; dòng `he-thong` giữ làm ghi chú), cuộc họp MỚI NHẤT trước; dòng không có `sid` (chat thường trong phòng) vào `ngoai_hop`. Trong mỗi nhóm các dòng xếp cũ → mới theo `ts`
 *  (cùng giây giữ thứ tự nhận vào). Nhóm theo Map nên mã như `__proto__` chỉ là một mã. Đầu vào không phải mảng → rỗng. */
export function gomCuocHop(ds: readonly DongHop[] | null | undefined): HopNgay {
  const dong = mangAnToan(ds).filter((d): d is DongHop => !!d && typeof d === 'object').map((d, i) => ({ d, i, ms: msDongHop(d.ts) }));
  dong.sort((a, b) => (Number.isNaN(a.ms) || Number.isNaN(b.ms) || a.ms === b.ms ? a.i - b.i : a.ms - b.ms));
  const nhom = new Map<string, DongHop[]>();
  const ngoai: DongHop[] = [];
  for (const { d } of dong) {
    const sid = typeof d.sid === 'string' ? d.sid : '';
    if (!sid) { ngoai.push(d); continue; }
    const l = nhom.get(sid);
    if (l) l.push(d);
    else nhom.set(sid, [d]);
  }
  const cuoc_hop: CuocHop[] = [];
  for (const [sid, ds_nhom] of nhom) {
    let da_ket_luan = false;
    const dong_bb: DongBienBan[] = ds_nhom.map((d) => {
      const r = { ...d, sau_ket_luan: da_ket_luan };
      if (d.kind === 'tong-hop') da_ket_luan = true;
      return r;
    });
    const so: SoDemHop = { tra_loi: 0, phan_bien: 0, de_xuat: 0, he_thong: 0, khac: 0, viec_giao: 0 };
    const du = new Set<string>();
    for (const d of dong_bb) {
      if (d.kind === 'tra-loi') { if (d.sau_ket_luan) so.viec_giao++; else so.tra_loi++; } else if (d.kind === 'phan-bien') so.phan_bien++;
      else if (d.kind === 'de-xuat') so.de_xuat++;
      else if (d.kind === 'he-thong') so.he_thong++;
      else if (d.kind !== 'hoi' && d.kind !== 'tong-hop') so.khac++;
      if ((d.kind === 'tra-loi' || d.kind === 'phan-bien') && !d.sau_ket_luan && laNguoiThat(d.who)) du.add(d.who);
    }
    const hoi = dong_bb.find((d) => d.kind === 'hoi');
    const kl = dong_bb.find((d) => d.kind === 'tong-hop');
    const phong = dong_bb.find((d) => d.room === 'tele' || d.room === 'web');
    cuoc_hop.push({
      sid, bat_dau: dong_bb[0].ts, ket_thuc: dong_bb[dong_bb.length - 1].ts, chu_de: hoi?.text ?? '', room: phong ? phong.room : '',
      nguoi_du: [...du], chi_huy: kl && laNguoiThat(kl.who) ? kl.who : '', ket_luan: kl?.text ?? '', co_ket_luan: !!kl, bi_huy: dong_bb.some((d) => d.kind === 'he-thong' && d.text.startsWith(DAU_HUY_HOP)), so, ngay_goc: ngayTuMaHop(sid), dong: dong_bb,
    });
  }
  cuoc_hop.sort((a, b) => {
    const x = msDongHop(b.bat_dau) - msDongHop(a.bat_dau);
    return Number.isNaN(x) || x === 0 ? soSanhChu(b.sid, a.sid) : x;
  });
  return { cuoc_hop, ngoai_hop: ngoai.map((d) => ({ ...d, sau_ket_luan: false })), tong_dong: dong.length };
}

export type TomTatHopNgay = { so_cuoc_hop: number; co_ket_luan: number; chua_ket_luan: number; de_xuat: number; tin_ngoai_hop: number };
/** Đếm cho dòng tóm tắt đầu mảng ("3 cuộc họp · 2 có kết luận · 5 đề xuất giao việc · 4 tin ngoài cuộc họp"). */
export function tomTatHopNgay(h: HopNgay | null | undefined): TomTatHopNgay {
  const t: TomTatHopNgay = { so_cuoc_hop: 0, co_ket_luan: 0, chua_ket_luan: 0, de_xuat: 0, tin_ngoai_hop: 0 };
  for (const c of mangAnToan(h?.cuoc_hop)) {
    t.so_cuoc_hop++;
    if (c.co_ket_luan) t.co_ket_luan++;
    else t.chua_ket_luan++;
    t.de_xuat += c.so.de_xuat;
  }
  t.tin_ngoai_hop = mangAnToan(h?.ngoai_hop).length;
  return t;
}

/** Phòng TẮT: VClaw ghi `last: null` và `meetings_7d: 0` làm chỗ giữ chỗ (không phải sự thật "chưa họp lần nào") nên giao diện nói "không có số liệu", không nói "chưa có cuộc họp nào". */
export const NHAN_KHONG_SO_LIEU_PHONG_TAT = 'không có số liệu khi phòng tắt';
export type TinhTrangPhong = 'chua-ghi' | 'tat' | 'bat';
export type DongPhongTacChien = {
  tinh_trang: TinhTrangPhong; nhan_tinh_trang: string;
  /** trạng thái máy chủ của TRANG CỤC BỘ (không phải "đang họp"): đang chạy / không chạy / chưa rõ */
  chay: 'dang-chay' | 'khong-chay' | 'chua-ro'; nhan_chay: string;
  /** địa chỉ gốc ĐÃ qua diaChiPhongTacChien — chỉ khi phòng đang bật; nơi duy nhất giao diện được lấy `href` */
  url: string | null;
  gan_nhat: { sid: string; chu_de: string; ts: string; nhan_gio: string; nhan_so_nguoi: string } | null;
  nhan_7_ngay: string;
};
/** Khối `warroom` của trạng thái → mọi chữ cần hiện ở dải trạng thái. null (VClaw chưa ghi khối) KHÁC enabled=false (đã ghi, đang tắt). Địa chỉ được kiểm LẠI bằng diaChiPhongTacChien dù dữ liệu
 *  thường đã được làm sạch ở máy chủ (đây là chốt chặn cuối trước khi thành thuộc tính href). */
export function dongPhongTacChien(w: WarRoomVclaw | null | undefined, bay_gio: number): DongPhongTacChien {
  if (!w) return { tinh_trang: 'chua-ghi', nhan_tinh_trang: 'Chưa ghi', chay: 'chua-ro', nhan_chay: 'Chưa rõ', url: null, gan_nhat: null, nhan_7_ngay: 'chưa rõ' };
  const bat = w.enabled === true;
  const chay = !bat ? 'khong-chay' : w.running === true ? 'dang-chay' : w.running === false ? 'khong-chay' : 'chua-ro';
  const l = w.last;
  const n = l && typeof l.n === 'number' && Number.isFinite(l.n) ? l.n : null;
  const m7 = typeof w.meetings_7d === 'number' && Number.isFinite(w.meetings_7d) ? w.meetings_7d : null;
  return {
    tinh_trang: bat ? 'bat' : 'tat', nhan_tinh_trang: bat ? 'Đang bật' : 'Đang TẮT',
    chay, nhan_chay: chay === 'dang-chay' ? 'Đang chạy' : chay === 'khong-chay' ? 'Không chạy' : 'Chưa rõ',
    url: bat ? diaChiPhongTacChien(w.url) : null,
    gan_nhat: l ? { sid: l.sid, chu_de: l.topic, ts: l.ts, nhan_gio: tuoiTuongDoi(l.ts, bay_gio), nhan_so_nguoi: n === null ? '' : `${n} thành viên` } : null,
    nhan_7_ngay: !bat ? NHAN_KHONG_SO_LIEU_PHONG_TAT : m7 === null ? 'chưa rõ' : m7 === 0 ? 'chưa có cuộc họp nào' : `${m7} cuộc họp`,
  };
}

/** Khi VClaw đã im quá ngưỡng (45 phút) thì "Đang chạy" của trang cục bộ và "cuộc họp gần nhất" là ảnh chụp CŨ → câu cảnh báo; VClaw còn báo đều (hoặc chưa có mốc giờ) → null. */
export function cauSoLieuPhongCu(updated: string | null | undefined, bay_gio: number): string | null {
  const phut = vclawKhongPhanHoi(updated, bay_gio);
  return phut === null ? null : `Số liệu cũ: VClaw báo lần cuối lúc ${gioVaNgay(updated)} (${thoiGianImLang(phut)} trước) — trạng thái trang cục bộ và cuộc họp gần nhất có thể đã đổi.`;
}
